// src/components/collection/incentives-collection.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EgdsImageFragment on Image {\n    description\n    url\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment CollectionHeroImageFragment on CollectionHeroImage {\n    image {\n      url\n      description\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment CollectionClickstreamAnalyticsFragment on CollectionClickstreamAnalytics {\n    event {\n      eventCategory\n      eventName\n      eventType\n      eventVersion\n    }\n    payload {\n      collectionId\n      collectionType\n      componentPosition\n      destinationGeoId\n      productId\n      trackingId\n      componentName\n      componentId\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    __typename\n    accessibility\n    primary\n    disabled\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesActionLinkFragment on IncentivesActionLink {\n    resource {\n      value\n    }\n    button {\n      ...EGDSButtonFragment\n    }\n    accessibility\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n    clickAnalytics {\n      linkName\n      referrerId\n    }\n    presentedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n    selectedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment CollectionDialogFragment on TermsAndConditions {\n    linkText\n    title\n    body\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesMediaLinkFragment on IncentivesMediaLink {\n    accessibility\n    clickAnalytics {\n      linkName\n      referrerId\n    }\n    image {\n      ... on Image {\n        description\n        url\n        thumbnailClickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n    resource {\n      value\n    }\n    selectedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesCollectionHeaderFragment on IncentivesCollectionHeader {\n    title @skip(if: $hideHeaderTitle)\n    subtitle @skip(if: $hideHeaderSubtitle)\n    description @skip(if: $hideHeaderDescription)\n    termsAndConditionsDialog @skip(if: $hideTermsAndConditions) {\n      ...CollectionDialogFragment\n    }\n    carouselCTAButton @skip(if: $hideCarouselCTA) {\n      ...IncentivesActionLinkFragment\n    }\n    collectionGraphicLink {\n      ...IncentivesMediaLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesCollectionErrorFragment on IncentivesCollectionError {\n    collectionHeader: header {\n      ...IncentivesCollectionHeaderFragment\n    }\n    action {\n      ...IncentivesActionLinkFragment\n    }\n    heroImage {\n      ...CollectionHeroImageFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    __typename\n    description\n    id\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment IllustrationFragment on Illustration {\n    description\n    illustrationUrl: url\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment MarkFragments on Mark {\n    description\n    id\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ...IconFragment\n    ...MarkFragments\n    ...IllustrationFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBadgeFragment on EGDSBadge {\n    text\n    theme\n    graphic {\n      ...UIGraphicFragment\n    }\n    size\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSHeadingFragment on EGDSHeading {\n    text\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    decorative\n    text\n    theme\n    weight\n  }\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextFragment on EGDSText {\n    __typename\n    ...EGDSPlainTextFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSSpannableTextFragment\n    ...EGDSParagraphFragment\n    ...EGDSHeadingFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesOfferTileOptionFragment on IncentivesOfferTileOption {\n    info {\n      ...EGDSGraphicTextFragment\n    }\n    time {\n      ...EGDSSpannableTextFragment\n    }\n    badge {\n      ...EGDSBadgeFragment\n    }\n    origin {\n      ...EGDSGraphicTextFragment\n    }\n    destination {\n      ...EGDSGraphicTextFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesOfferTileFragment on IncentivesOfferTile {\n    options {\n      ...IncentivesOfferTileOptionFragment\n    }\n    price {\n      ...EGDSSpannableTextFragment\n    }\n    cardLink {\n      ...IncentivesActionLinkFragment\n    }\n    badge {\n      ...EGDSBadgeFragment\n    }\n    timeFoundAgo\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesTileContentFragment on IncentivesTileContent {\n    title\n    subTitle\n    description\n  }\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesHeroTileFragment on IncentivesHeroTile {\n    content {\n      ...IncentivesTileContentFragment\n    }\n    offers {\n      ...IncentivesOfferTileFragment\n    }\n    action {\n      ...IncentivesActionLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesResultsSummaryFragment on IncentivesResultsSummary {\n    dealsDate {\n      ...EGDSSpannableTextFragment\n    }\n    message\n  }\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesHeroTilesBodyFragment on IncentivesHeroTilesBody {\n    heroTiles: tiles {\n      ...IncentivesHeroTileFragment\n    }\n    heroSummary: summary @skip(if: $hideSummary) {\n      ...IncentivesResultsSummaryFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesLoadMoreButtonFragment on CollectionPaginationAction {\n    button {\n      ...EGDSButtonFragment\n    }\n    paginationQuery {\n      paginationContext {\n        maxPageSize\n        offset\n        pageSize\n      }\n    }\n    selectedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment EgdsMediaItemFragment on MediaItem {\n    media {\n      ... on Image {\n        ...EgdsImageFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGalleryCarouselFragment on EGDSGalleryCarousel {\n    accessibilityHeadingText\n    media {\n      ... on MediaItem {\n        ...EgdsMediaItemFragment\n      }\n    }\n    nextButtonText\n    previousButtonText\n  }\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesMediaFragment on IncentivesMedia {\n    gallery {\n      ...EGDSGalleryCarouselFragment\n    }\n    badges {\n      ...EGDSBadgeFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesMediaTilePriceFragment on IncentivesMediaTilePrice {\n    badge {\n      ...EGDSBadgeFragment\n    }\n    propertyPrice {\n      ...PriceSummaryFragment\n      options {\n        leadingCaption\n        displayPrice {\n          formatted\n        }\n        disclaimer {\n          value\n        }\n        priceDisclaimer {\n          content\n          primaryButton {\n            text\n          }\n          trigger {\n            icon {\n              description\n            }\n          }\n        }\n        accessibilityLabel\n        strikeOut {\n          formatted\n        }\n        loyaltyPrice {\n          unit\n          amount {\n            formatted\n          }\n          totalStrikeOutPoints {\n            formatted\n          }\n        }\n      }\n      priceMessaging {\n        value\n        theme\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment ProductRatingSummaryFragment on ProductRatingSummary {\n    accessibilityLabel\n    primary\n    secondary\n    supportingMessages {\n      ... on EGDSPlainText {\n        text\n      }\n    }\n    theme\n  }\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesMediaTileFragment on IncentivesMediaTile {\n    media {\n      ...IncentivesMediaFragment\n    }\n    rating {\n      ...EGDSSpannableTextFragment\n    }\n    productRatingSummary {\n      accessibilityLabel\n      primary\n      secondary\n      supportingMessages {\n        ... on EGDSPlainText {\n          text\n        }\n      }\n      theme\n    }\n    content {\n      ...IncentivesTileContentFragment\n    }\n    price {\n      ...IncentivesMediaTilePriceFragment\n    }\n    cardLink {\n      ...IncentivesActionLinkFragment\n    }\n    action {\n      ...IncentivesActionLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesMediaTilesBodyFragment on IncentivesMediaTilesBody {\n    tiles {\n      ...IncentivesMediaTileFragment\n    }\n    summary @skip(if: $hideSummary) {\n      ...IncentivesResultsSummaryFragment\n    }\n    loadMoreAction @include(if: $isActiveLoadMore) {\n      ...IncentivesLoadMoreButtonFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesActionLinkButtonFragment on IncentivesActionLink {\n    resource {\n      value\n    }\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n    clickAnalytics {\n      linkName\n      referrerId\n    }\n    accessibility\n  }\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesContentItemFragment on IncentivesContentItem {\n    actionLink {\n      ...IncentivesActionLinkButtonFragment\n    }\n    incentivesImage {\n      image {\n        description\n        url\n      }\n    }\n    title\n    subtitle\n    description\n    cardSize\n    recommendationId\n  }\n\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesCollectionSuccessFragment on IncentivesCollectionSuccess {\n    collectionHeader: header {\n      ...IncentivesCollectionHeaderFragment\n    }\n    collectionItems {\n      ...IncentivesContentItemFragment\n    }\n    collectionBody {\n      ... on IncentivesMediaTilesBody {\n        ...IncentivesMediaTilesBodyFragment\n      }\n      ... on IncentivesHeroTilesBody {\n        ...IncentivesHeroTilesBodyFragment\n      }\n    }\n    heroImage {\n      ...CollectionHeroImageFragment\n    }\n    egRecommendationResponseId\n    impressionAnalytics {\n      event\n      linkName\n      referrerId\n    }\n    presentedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  query CollectionQuery(\n    $context: ContextInput!\n    $collectionId: String!\n    $hideSummary: Boolean = false\n    $hideHeaderTitle: Boolean = false\n    $hideHeaderSubtitle: Boolean = false\n    $hideHeaderDescription: Boolean = false\n    $hideTermsAndConditions: Boolean = false\n    $hideCarouselCTA: Boolean = true\n    $isActiveLoadMore: Boolean = true\n    $paginationContext: CollectionPaginationContextInput\n  ) {\n    incentivesCollectionView(context: $context, collectionId: $collectionId, paginationContext: $paginationContext) {\n      ... on IncentivesCollectionError {\n        ...IncentivesCollectionErrorFragment\n      }\n      ... on IncentivesCollectionSuccess {\n        ...IncentivesCollectionSuccessFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableListItemFragment on EGDSSpannableListItem {\n    graphic {\n      ...UIGraphicFragment\n    }\n    subText\n    text {\n      ...EGDSSpannableTextFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableListFragment on EGDSSpannableList {\n    items {\n      ...EGDSSpannableListItemFragment\n    }\n    listType\n  }\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  fragment PackagesIncentivesMediaTileFragment on IncentivesMediaTile {\n    media {\n      ...IncentivesMediaFragment\n    }\n    details {\n      ...EGDSSpannableListFragment\n    }\n    content {\n      ...IncentivesTileContentFragment\n    }\n    price {\n      ...IncentivesMediaTilePriceFragment\n    }\n    cardLink {\n      ...IncentivesActionLinkFragment\n    }\n    action {\n      ...IncentivesActionLinkFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment CollectionGroupedMediaTilesBodyFragment on CollectionGroupedMediaTilesBody {\n    tiles {\n      content {\n        ...IncentivesTileContentFragment\n      }\n      ctaButton @skip(if: $hideCarouselCTA) {\n        ...IncentivesActionLinkFragment\n      }\n      offers {\n        ...PackagesIncentivesMediaTileFragment\n      }\n    }\n    summary @skip(if: $hideSummary) {\n      ...IncentivesResultsSummaryFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  query CollectionGridQuery(\n    $context: ContextInput!\n    $collectionId: String!\n    $collectionItemClickthrough: CollectionItemClickthrough\n    $hideHeaderTitle: Boolean = false\n    $hideHeaderSubtitle: Boolean = false\n    $hideHeaderDescription: Boolean = false\n    $hideSummary: Boolean = false\n    $hideTermsAndConditions: Boolean = false\n    $hideCarouselCTA: Boolean = true\n    $isActiveLoadMore: Boolean = true\n    $paginationContext: CollectionPaginationContextInput\n    $expectedCollectionType: CollectionType\n    $pageContext: PageContextInput\n    $collectionGroupsPageSize: Int\n    $collectionItemsPerGroupPageSize: Int\n    $displayFlightDealScoreBadge: Boolean = false\n  ) {\n    incentivesCollection(\n      context: $context\n      collectionId: $collectionId\n      collectionItemClickthrough: $collectionItemClickthrough\n      collectionGroupsPageSize: $collectionGroupsPageSize\n      collectionItemsPerGroupPageSize: $collectionItemsPerGroupPageSize\n      paginationContext: $paginationContext\n      expectedCollectionType: $expectedCollectionType\n      pageContext: $pageContext\n      displayFlightDealScoreBadge: $displayFlightDealScoreBadge\n    ) {\n      collectionHeader {\n        ...IncentivesCollectionHeaderFragment\n      }\n      collectionBody {\n        ... on IncentivesMediaTilesBody {\n          ...IncentivesMediaTilesBodyFragment\n        }\n        ... on IncentivesHeroTilesBody {\n          ...IncentivesHeroTilesBodyFragment\n        }\n        ... on CollectionGroupedMediaTilesBody {\n          ...CollectionGroupedMediaTilesBodyFragment\n        }\n      }\n      impressionAnalytics {\n        event\n        linkName\n        referrerId\n      }\n      egRecommendationResponseId\n      presentedAnalytics {\n        ...CollectionClickstreamAnalyticsFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesMediaTileFragment on IncentivesMediaTile {\n    media {\n      ...IncentivesMediaFragment\n    }\n    rating {\n      ...EGDSSpannableTextFragment\n    }\n    productRatingSummary {\n      accessibilityLabel\n      primary\n      secondary\n      supportingMessages {\n        ... on EGDSPlainText {\n          text\n        }\n      }\n      theme\n    }\n    content {\n      ...IncentivesTileContentFragment\n    }\n    price {\n      ...IncentivesMediaTilePriceFragment\n    }\n    cardLink {\n      ...IncentivesActionLinkFragment\n    }\n    action {\n      ...IncentivesActionLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  query CollectionLodgingCarouselComponentLoad(\n    $context: ContextInput!\n    $collectionId: String!\n    $collectionItemClickthrough: CollectionItemClickthrough\n    $hideHeaderTitle: Boolean = false\n    $hideHeaderSubtitle: Boolean = false\n    $hideHeaderDescription: Boolean = false\n    $hideSummary: Boolean = false\n    $hideTermsAndConditions: Boolean = false\n    $hideCarouselCTA: Boolean = true\n    $paginationContext: CollectionPaginationContextInput!\n    $pageContext: PageContextInput\n  ) {\n    collectionLodgingCarousel(\n      context: $context\n      collectionId: $collectionId\n      collectionItemClickthrough: $collectionItemClickthrough\n      paginationContext: $paginationContext\n      pageContext: $pageContext\n    ) {\n      collectionHeader {\n        ...IncentivesCollectionHeaderFragment\n      }\n      collectionBody {\n        ... on CollectionCarouselMediaTilesBody {\n          ...CollectionCarouselMediaTilesBodyFragment\n        }\n      }\n      heroImage {\n        ...CollectionHeroImageFragment\n      }\n      impressionAnalytics {\n        event\n        linkName\n        referrerId\n      }\n      presentedAnalytics {\n        ...CollectionClickstreamAnalyticsFragment\n      }\n    }\n  }\n\n  fragment CollectionCarouselMediaTilesBodyFragment on CollectionCarouselMediaTilesBody {\n    tiles {\n      ...IncentivesMediaTileFragment\n    }\n    summary @skip(if: $hideSummary) {\n      ...IncentivesResultsSummaryFragment\n    }\n    previousSelectedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n    nextSelectedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n    carouselCTAButton @skip(if: $hideCarouselCTA) {\n      ...IncentivesActionLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  query CollectionFlightsCarouselComponent(\n    $context: ContextInput!\n    $collectionId: String!\n    $hideHeaderTitle: Boolean = false\n    $hideHeaderSubtitle: Boolean = false\n    $hideHeaderDescription: Boolean = false\n    $hideSummary: Boolean = false\n    $hideTermsAndConditions: Boolean = false\n    $hideCarouselCTA: Boolean = false\n    $paginationContext: CollectionPaginationContextInput!\n    $pageContext: PageContextInput\n    $collectionGroupsPageSize: Int\n    $collectionItemsPerGroupPageSize: Int\n    $displayFlightDealScoreBadge: Boolean = false\n  ) {\n    collectionFlightsCarousel(\n      context: $context\n      collectionId: $collectionId\n      paginationContext: $paginationContext\n      pageContext: $pageContext\n      collectionGroupsPageSize: $collectionGroupsPageSize\n      collectionItemsPerGroupPageSize: $collectionItemsPerGroupPageSize\n      displayFlightDealScoreBadge: $displayFlightDealScoreBadge\n    ) {\n      collectionHeader {\n        ...IncentivesCollectionHeaderFragment\n      }\n      collectionBody {\n        ... on CollectionCarouselHeroTilesBody {\n          ...CollectionCarouselHeroTilesBodyFragment\n        }\n      }\n      impressionAnalytics {\n        event\n        linkName\n        referrerId\n      }\n      presentedAnalytics {\n        ...CollectionClickstreamAnalyticsFragment\n      }\n    }\n  }\n\n  fragment CollectionCarouselHeroTilesBodyFragment on CollectionCarouselHeroTilesBody {\n    tiles {\n      ...CollectionCarouselHeroTileFragment\n    }\n    summary @skip(if: $hideSummary) {\n      ...IncentivesResultsSummaryFragment\n    }\n  }\n\n  fragment CollectionCarouselHeroTileFragment on CollectionCarouselHeroTile {\n    previousSelectedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n    nextSelectedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n    content {\n      ...IncentivesTileContentFragment\n    }\n    offers {\n      ...IncentivesOfferTileFragment\n    }\n    selectedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n    carouselCTAButton {\n      ...IncentivesActionLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  fragment PackagesCarouselBodyFragment on CollectionTabbedCarouselMediaTilesBody {\n    tiles {\n      content {\n        ...IncentivesTileContentFragment\n      }\n      ctaButton @skip(if: $hideCarouselCTA) {\n        ...IncentivesActionLinkFragment\n      }\n      nextSelectedAnalytics {\n        ...CollectionClickstreamAnalyticsFragment\n      }\n      offers {\n        ...PackagesIncentivesMediaTileFragment\n      }\n      presentedAnalytics {\n        ...CollectionClickstreamAnalyticsFragment\n      }\n      previousSelectedAnalytics {\n        ...CollectionClickstreamAnalyticsFragment\n      }\n      selectedAnalytics {\n        ...CollectionClickstreamAnalyticsFragment\n      }\n    }\n    summary @skip(if: $hideSummary) {\n      ...IncentivesResultsSummaryFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  query CollectionPackagesCarouselComponent(\n    $context: ContextInput!\n    $collectionId: String!\n    $hideHeaderTitle: Boolean = false\n    $hideHeaderSubtitle: Boolean = false\n    $hideHeaderDescription: Boolean = false\n    $hideSummary: Boolean = false\n    $hideTermsAndConditions: Boolean = false\n    $hideCarouselCTA: Boolean = true\n    $paginationContext: CollectionPaginationContextInput!\n    $pageContext: PageContextInput\n    $collectionGroupsPageSize: Int\n    $collectionItemsPerGroupPageSize: Int\n  ) {\n    collectionPackagesCarousel(\n      context: $context\n      collectionId: $collectionId\n      paginationContext: $paginationContext\n      pageContext: $pageContext\n      collectionGroupsPageSize: $collectionGroupsPageSize\n      collectionItemsPerGroupPageSize: $collectionItemsPerGroupPageSize\n    ) {\n      collectionHeader {\n        ...IncentivesCollectionHeaderFragment\n      }\n      collectionBody {\n        ...PackagesCarouselBodyFragment\n      }\n      impressionAnalytics {\n        event\n        linkName\n        referrerId\n      }\n      presentedAnalytics {\n        ...CollectionClickstreamAnalyticsFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
import React42 from "react";
import { gql as gql40, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker3 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/incentives-collection-error/incentives-collection-error.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSButtonSize } from "@egds/react-core/button";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
// ../internal/src/components/collection-hero-image/collection-hero-image.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSFigure, EGDSFigureAspectRatioType } from "@egds/react-core/images";
import { EGDSView, EGDSViewRow } from "@egds/react-core/view";
import { ViewExtraLarge, ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// ../internal/src/components/egds-media-item/egds-image.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSImage } from "@egds/react-core/images";
var fragment = gql(_templateObject());
var Image = function(param) {
    var data = param.data;
    var url = data.url, description = data.description;
    return /* @__PURE__ */ React.createElement(EGDSImage, {
        placeholderImage: true,
        alt: description,
        src: url
    });
};
Image.fragment = fragment;
Image.displayName = "Image";
// ../internal/src/components/collection-hero-image/collection-hero-image.tsx
var __fragment = gql2(_templateObject1());
var CollectionHeroImage = function(param) {
    var data = param.data;
    if (!(data === null || data === void 0 ? void 0 : data.image.url)) {
        return null;
    }
    return /* @__PURE__ */ React2.createElement(Viewport, null, /* @__PURE__ */ React2.createElement(ViewSmall, null, /* @__PURE__ */ React2.createElement(EGDSFigure, {
        ratio: EGDSFigureAspectRatioType.R1_1
    }, /* @__PURE__ */ React2.createElement(Image, {
        data: data.image
    }))), /* @__PURE__ */ React2.createElement(ViewMedium, null, /* @__PURE__ */ React2.createElement(EGDSFigure, {
        ratio: EGDSFigureAspectRatioType.R16_9
    }, /* @__PURE__ */ React2.createElement(Image, {
        data: data.image
    }))), /* @__PURE__ */ React2.createElement(ViewLarge, null, /* @__PURE__ */ React2.createElement(EGDSFigure, {
        ratio: EGDSFigureAspectRatioType.R21_9
    }, /* @__PURE__ */ React2.createElement(Image, {
        data: data.image
    }))), /* @__PURE__ */ React2.createElement(ViewExtraLarge, null, /* @__PURE__ */ React2.createElement(EGDSView, null, /* @__PURE__ */ React2.createElement(EGDSViewRow, null, /* @__PURE__ */ React2.createElement(EGDSFigure, {
        ratio: EGDSFigureAspectRatioType.R21_9,
        roundcorner: true
    }, /* @__PURE__ */ React2.createElement(Image, {
        data: data.image
    }))))));
};
CollectionHeroImage.fragment = __fragment;
CollectionHeroImage.displayName = "CollectionHeroImage";
// ../internal/src/components/incentives-action-link/incentives-action-link.tsx
import React4 from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utility/analytics/get-recommendation.ts
var getRecommendation = function(collectionItem) {
    var _collectionItem_price;
    var _collectionItem_badges;
    return {
        recommendationId: collectionItem.recommendationId,
        rank: collectionItem.index,
        presentationDetails: _object_spread({
            name: collectionItem.title,
            imageUrl: collectionItem.imageUrl,
            badges: (_collectionItem_badges = collectionItem.badges) !== null && _collectionItem_badges !== void 0 ? _collectionItem_badges : ""
        }, ((_collectionItem_price = collectionItem.price) === null || _collectionItem_price === void 0 ? void 0 : _collectionItem_price.currency) && {
            price: {
                displayPrice: collectionItem.price.displayPrice,
                currency: collectionItem.price.currency
            }
        })
    };
};
// ../internal/src/utility/analytics/get-recommendation-event.ts
var getRecommendationEvent = function(eventInfo, eventName, eventType) {
    return {
        eventType: eventType !== null && eventType !== void 0 ? eventType : "recommendationInteraction",
        eventName: eventName,
        egRecommendationResponseId: eventInfo.egRecommendationResponseId,
        recommendationTitle: eventInfo.title,
        component: eventInfo.componentType,
        componentElement: "thumbnail"
    };
};
// ../internal/src/utility/analytics/get-recommendation-clicked-message.ts
var getRecommendationClickedMessage = function(collectionEventingDetails, eventType) {
    if (!collectionEventingDetails || !collectionEventingDetails.items[0]) {
        return void 0;
    }
    var recommendationEvent = _object_spread_props(_object_spread({}, getRecommendationEvent(collectionEventingDetails, "recommendationClicked", eventType)), {
        recommendations: [
            getRecommendation(collectionEventingDetails.items[0])
        ]
    });
    return [
        {
            schemaName: "allRecommendations",
            messageContent: recommendationEvent
        }
    ];
};
// ../internal/src/utility/analytics/get-recommendation-seen-message.ts
var getRecommendationSeenMessage = function(collectionEventingDetails) {
    var scroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", eventType = arguments.length > 2 ? arguments[2] : void 0;
    var _collectionEventingDetails_items;
    if (!collectionEventingDetails) {
        return void 0;
    }
    var recommendations = (_collectionEventingDetails_items = collectionEventingDetails.items) === null || _collectionEventingDetails_items === void 0 ? void 0 : _collectionEventingDetails_items.filter(function(n) {
        return n;
    }).map(function(resultItem) {
        return getRecommendation(resultItem);
    });
    var recommendationEvent = _object_spread_props(_object_spread({}, getRecommendationEvent(collectionEventingDetails, "recommendationSeen", eventType)), {
        scroll: scroll,
        recommendations: recommendations
    });
    return (recommendations === null || recommendations === void 0 ? void 0 : recommendations.length) ? [
        {
            schemaName: "allRecommendations",
            messageContent: recommendationEvent
        }
    ] : void 0;
};
// ../internal/src/utility/analytics/eg-clickstream-helper.ts
var buildClickstreamAnalyticsEvent = function(clickstreamAnalytics) {
    var _clickstreamAnalytics_event = clickstreamAnalytics.event, eventName = _clickstreamAnalytics_event.eventName, eventType = _clickstreamAnalytics_event.eventType, eventVersion = _clickstreamAnalytics_event.eventVersion, eventCategory = _clickstreamAnalytics_event.eventCategory;
    var _clickstreamAnalytics_payload = clickstreamAnalytics.payload, collectionId = _clickstreamAnalytics_payload.collectionId, collectionType = _clickstreamAnalytics_payload.collectionType, productId = _clickstreamAnalytics_payload.productId, destinationGeoId = _clickstreamAnalytics_payload.destinationGeoId, trackingId = _clickstreamAnalytics_payload.trackingId, componentPosition = _clickstreamAnalytics_payload.componentPosition, componentName = _clickstreamAnalytics_payload.componentName, componentId = _clickstreamAnalytics_payload.componentId;
    var productObject = productId ? {
        product_list: [
            {
                product_id: productId
            }
        ]
    } : null;
    var destinationObject = destinationGeoId ? {
        destination: {
            destination_geo_id: destinationGeoId
        }
    } : null;
    var additionalContextObject = componentPosition || componentName || componentId ? {
        additional_context: {
            user_interface: {
                component_position: componentPosition,
                component_id: componentId,
                component_name: componentName
            }
        }
    } : null;
    var baseObject = {
        event: {
            event_name: eventName,
            event_version: eventVersion,
            event_type: eventType,
            event_category: eventCategory
        },
        incentive: {
            collection_id: collectionId,
            collection_type: collectionType.toLowerCase(),
            incentive_tracking_id: trackingId
        }
    };
    return _object_spread({}, baseObject, productObject, destinationObject, additionalContextObject);
};
// ../internal/src/utility/analytics/fragments/collection-clickstream-analytics-fragment.ts
import { gql as gql3 } from "@apollo/client";
var CollectionClickstreamAnalyticsFragment = gql3(_templateObject2());
// ../internal/src/components/egds-button/egds-button.tsx
import React3 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
var fragment2 = gql4(_templateObject3());
var Button = function(param) {
    var data = param.data, size = param.size, isFullWidth = param.isFullWidth, onClickHandler = param.onClickHandler, href = param.href, className = param.className, onClickCapture = param.onClickCapture, inverse = param.inverse;
    var __typename = data.__typename, primary = data.primary, accessibility = data.accessibility, disabled = data.disabled;
    if (!primary) {
        return null;
    }
    var ButtonComponent = EGDSPrimaryButton;
    if (__typename === "UISecondaryButton") {
        ButtonComponent = EGDSSecondaryButton;
    } else if (__typename === "UITertiaryButton") {
        ButtonComponent = EGDSTertiaryButton;
    }
    return /* @__PURE__ */ React3.createElement(ButtonComponent, {
        size: size,
        href: href,
        isFullWidth: isFullWidth,
        onClick: onClickHandler,
        disabled: disabled,
        className: className,
        onClickCapture: onClickCapture,
        inverse: inverse
    }, primary, /* @__PURE__ */ React3.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
Button.fragment = fragment2;
Button.displayName = "Button";
// ../internal/src/components/incentives-action-link/incentives-action-link.tsx
var __fragment2 = gql5(_templateObject4(), CollectionClickstreamAnalyticsFragment, Button.fragment);
var IncentivesActionLink = function(props) {
    var data = props.data, className = props.className, buttonSize = props.buttonSize, buttonIsFullWidth = props.buttonIsFullWidth, buttonClickHandler = props.buttonClickHandler, additionalUisPrimeMicroMessages = props.additionalUisPrimeMicroMessages, visuallyHidden = props.visuallyHidden, multiArmBanditTrack = props.multiArmBanditTrack, inverseButton = props.inverseButton;
    var accessibility = data.accessibility, resource = data.resource, clickAnalytics = data.clickAnalytics, button = data.button, selectedAnalytics = data.selectedAnalytics;
    var track = useEgClickstream();
    var clickTracker = useClickTracker();
    var onClickCapture = function() {
        if (selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(selectedAnalytics));
        }
        multiArmBanditTrack === null || multiArmBanditTrack === void 0 ? void 0 : multiArmBanditTrack();
        if (clickAnalytics.referrerId) {
            clickTracker(clickAnalytics.referrerId, clickAnalytics.linkName, void 0, additionalUisPrimeMicroMessages);
        }
    };
    if (button) {
        return /* @__PURE__ */ React4.createElement(Button, {
            data: button,
            href: resource.value,
            size: buttonSize,
            isFullWidth: buttonIsFullWidth,
            className: className,
            onClickHandler: buttonClickHandler,
            onClickCapture: onClickCapture,
            inverse: inverseButton
        });
    }
    return /* @__PURE__ */ React4.createElement("a", {
        href: resource.value,
        onClickCapture: onClickCapture,
        className: className
    }, /* @__PURE__ */ React4.createElement("span", {
        className: visuallyHidden ? "is-visually-hidden" : ""
    }, accessibility));
};
IncentivesActionLink.displayName = "IncentivesActionLink";
IncentivesActionLink.fragment = __fragment2;
// ../internal/src/components/incentives-collection-header/incentives-collection-header.tsx
import React7 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// ../internal/src/components/collection-dialog/collection-dialog.tsx
import React5 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSText } from "@egds/react-core/text";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useDialog } from "@shared-ui/dialog-context";
var __fragment3 = gql6(_templateObject5());
var CollectionDialog = function(param) {
    var data = param.data, _param_isLinkInline = param.isLinkInline, isLinkInline = _param_isLinkInline === void 0 ? false : _param_isLinkInline;
    var triggerRef = React5.useRef(null);
    var dialogId = React5.useMemo(function() {
        return Math.random().toString(36).substring(2, 7);
    }, []);
    var linkText = data.linkText, title = data.title, body = data.body;
    var _useDialog = _sliced_to_array(useDialog("collection-dialog-".concat(dialogId)), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var openDialog = React5.useCallback(function() {
        dialogActions.openDialog();
    }, [
        dialogActions
    ]);
    var closeDialog = React5.useCallback(function() {
        dialogActions.closeDialog();
    }, [
        dialogActions
    ]);
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(EGDSSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React5.createElement(DialogComponent, null, /* @__PURE__ */ React5.createElement(EGDSSheet, {
        isVisible: isDialogOpen,
        type: "centered",
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React5.createElement(EGDSToolbar, {
        navigationContent: {
            onClick: closeDialog,
            navIconLabel: "Close Dialog"
        },
        toolbarTitle: title
    }), /* @__PURE__ */ React5.createElement(EGDSSheetContent, null, /* @__PURE__ */ React5.createElement(EGDSText, {
        size: 300
    }, body))))), /* @__PURE__ */ React5.createElement(EGDSLink, {
        inline: isLinkInline
    }, /* @__PURE__ */ React5.createElement("button", {
        onClick: openDialog,
        ref: triggerRef,
        type: "button"
    }, linkText)));
};
CollectionDialog.fragment = __fragment3;
CollectionDialog.displayName = "CollectionDialog";
// ../internal/src/components/incentives-media-link/incentives-media-link.tsx
import React6 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage as EGDSImage2, EGDSImageLink } from "@egds/react-core/images";
import { useClickTracker as useClickTracker2, useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
var __fragment4 = gql7(_templateObject6(), CollectionClickstreamAnalyticsFragment);
var IncentivesMediaLink = function(props) {
    var track = useEgClickstream2();
    var clickTracker = useClickTracker2();
    var data = props.data, multiArmBanditTrack = props.multiArmBanditTrack;
    var accessibility = data.accessibility, clickAnalytics = data.clickAnalytics, image = data.image, resource = data.resource, selectedAnalytics = data.selectedAnalytics;
    if (!image) {
        return null;
    }
    var thumbnailClickAnalytics = image.thumbnailClickAnalytics;
    var onClickCapture = function() {
        if (thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId) {
            clickTracker(thumbnailClickAnalytics.referrerId, thumbnailClickAnalytics.linkName, void 0);
        }
        if (selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(selectedAnalytics));
        }
        multiArmBanditTrack === null || multiArmBanditTrack === void 0 ? void 0 : multiArmBanditTrack();
        if (clickAnalytics.referrerId) {
            clickTracker(clickAnalytics.referrerId, clickAnalytics.linkName, void 0);
        }
    };
    return /* @__PURE__ */ React6.createElement(EGDSFigure2, {
        imageFit: "contain",
        ratio: EGDSFigureAspectRatioType2.R16_9
    }, /* @__PURE__ */ React6.createElement(EGDSImage2, {
        placeholderImage: true,
        alt: image.description,
        src: image.url
    }), /* @__PURE__ */ React6.createElement(EGDSImageLink, null, /* @__PURE__ */ React6.createElement("a", {
        href: resource.value,
        onClickCapture: onClickCapture,
        "data-stid": "brand-image-link"
    }, accessibility)));
};
IncentivesMediaLink.displayName = "IncentivesMediaLink";
IncentivesMediaLink.fragment = __fragment4;
// ../internal/src/components/incentives-collection-header/layout-values.ts
var imageSpacing = {
    margin: {
        blockend: "six"
    }
};
var titleSpacing = {
    margin: {
        blockstart: "two"
    }
};
var descriptionSpacing = {
    margin: {
        blockstart: "three"
    }
};
var multipleHeaderDescriptionSpacing = {
    margin: {
        blockstart: "one"
    }
};
var termsAndConditionSpacing = {
    margin: {
        blockstart: "two"
    }
};
// ../internal/src/components/incentives-collection-header/incentives-collection-header.tsx
var __fragment5 = gql8(_templateObject7(), CollectionDialog.fragment, IncentivesActionLink.fragment, IncentivesMediaLink.fragment);
var IncentivesCollectionHeader = function(param) {
    var data = param.data, _param_multipleHeader = param.multipleHeader, multipleHeader = _param_multipleHeader === void 0 ? false : _param_multipleHeader, _param_textSize = param.textSize, textSize = _param_textSize === void 0 ? 400 : _param_textSize, _param_showCTAButton = param.showCTAButton, showCTAButton = _param_showCTAButton === void 0 ? false : _param_showCTAButton, _param_showTermsAndConditions = param.showTermsAndConditions, showTermsAndConditions = _param_showTermsAndConditions === void 0 ? false : _param_showTermsAndConditions, _param_isLinkInline = param.isLinkInline, isLinkInline = _param_isLinkInline === void 0 ? false : _param_isLinkInline;
    var title = data.title, subtitle = data.subtitle, description = data.description, termsAndConditionsDialog = data.termsAndConditionsDialog, carouselCTAButton = data.carouselCTAButton;
    return /* @__PURE__ */ React7.createElement(EGDSLayoutFlex, {
        direction: "column"
    }, subtitle && /* @__PURE__ */ React7.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React7.createElement(EGDSText2, null, subtitle)), /* @__PURE__ */ React7.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React7.createElement(Viewport2, null, /* @__PURE__ */ React7.createElement(ViewSmall2, null, /* @__PURE__ */ React7.createElement(EGDSSpacing, {
        margin: titleSpacing.margin
    }, /* @__PURE__ */ React7.createElement(EGDSHeading, {
        tag: multipleHeader ? "h2" : "h1",
        size: multipleHeader ? 5 : 2
    }, title))), /* @__PURE__ */ React7.createElement(ViewMedium2, null, /* @__PURE__ */ React7.createElement(EGDSSpacing, {
        margin: titleSpacing.margin
    }, /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(EGDSLayoutFlex, {
        space: "two",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React7.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React7.createElement(EGDSHeading, {
        tag: multipleHeader ? "h2" : "h1",
        size: multipleHeader ? 4 : 1,
        overflow: "wrap"
    }, title)), /* @__PURE__ */ React7.createElement(EGDSLayoutFlexItem, {
        alignSelf: "start",
        shrink: 0
    }, carouselCTAButton && showCTAButton && /* @__PURE__ */ React7.createElement(IncentivesActionLink, {
        data: carouselCTAButton
    })))))))), description && /* @__PURE__ */ React7.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React7.createElement(EGDSSpacing, {
        margin: multipleHeader ? multipleHeaderDescriptionSpacing.margin : descriptionSpacing.margin
    }, /* @__PURE__ */ React7.createElement(EGDSText2, {
        size: multipleHeader ? textSize : 500
    }, description))), termsAndConditionsDialog && showTermsAndConditions && /* @__PURE__ */ React7.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React7.createElement(EGDSSpacing, {
        margin: termsAndConditionSpacing.margin
    }, /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(CollectionDialog, {
        data: termsAndConditionsDialog,
        isLinkInline: isLinkInline
    })))));
};
IncentivesCollectionHeader.fragment = __fragment5;
IncentivesCollectionHeader.displayName = "IncentivesCollectionHeader";
// ../internal/src/components/incentives-view-content/incentives-view-content.tsx
import React8 from "react";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSView as EGDSView2, EGDSViewRow as EGDSViewRow2 } from "@egds/react-core/view";
var level1Spacing = {
    margin: {
        extra_large: {
            inline: "twelve"
        }
    },
    padding: {
        extra_large: {
            inline: "six"
        }
    }
};
var level2Spacing = {
    margin: {
        extra_large: {
            inline: "four"
        }
    }
};
var IncentivesViewContent = function(param) {
    var className = param.className, children = param.children;
    return /* @__PURE__ */ React8.createElement(EGDSView2, {
        className: className
    }, /* @__PURE__ */ React8.createElement(EGDSViewRow2, null, /* @__PURE__ */ React8.createElement(EGDSSpacing2, {
        margin: level1Spacing.margin,
        padding: level1Spacing.padding
    }, /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(EGDSSpacing2, {
        margin: level2Spacing.margin
    }, children)))));
};
IncentivesViewContent.displayName = "IncentivesViewContent";
// ../internal/src/components/incentives-collection-error/incentives-collection-error.tsx
var fragment3 = gql9(_templateObject8(), IncentivesCollectionHeader.fragment, CollectionHeroImage.fragment, IncentivesActionLink.fragment);
var buttonSpacing = {
    block: "six"
};
var IncentivesCollectionError = function(param) {
    var data = param.data;
    var collectionHeader = data.collectionHeader, action = data.action, heroImage = data.heroImage;
    return /* @__PURE__ */ React9.createElement(React9.Fragment, null, heroImage && /* @__PURE__ */ React9.createElement(CollectionHeroImage, {
        data: heroImage
    }), /* @__PURE__ */ React9.createElement(IncentivesViewContent, null, collectionHeader && /* @__PURE__ */ React9.createElement(IncentivesCollectionHeader, {
        data: collectionHeader
    })), (action === null || action === void 0 ? void 0 : action.button) && /* @__PURE__ */ React9.createElement(Viewport3, null, /* @__PURE__ */ React9.createElement(ViewSmall3, null, /* @__PURE__ */ React9.createElement(IncentivesViewContent, null, /* @__PURE__ */ React9.createElement(EGDSSpacing3, {
        margin: buttonSpacing
    }, /* @__PURE__ */ React9.createElement(IncentivesActionLink, {
        data: action,
        buttonSize: EGDSButtonSize.MEDIUM,
        buttonIsFullWidth: true
    })))), /* @__PURE__ */ React9.createElement(ViewMedium3, null, /* @__PURE__ */ React9.createElement(IncentivesViewContent, null, /* @__PURE__ */ React9.createElement(EGDSSpacing3, {
        margin: buttonSpacing
    }, /* @__PURE__ */ React9.createElement(IncentivesActionLink, {
        data: action,
        buttonSize: EGDSButtonSize.MEDIUM,
        buttonIsFullWidth: false
    }))))));
};
IncentivesCollectionError.fragment = fragment3;
IncentivesCollectionError.displayName = "IncentivesCollectionError";
var _obj;
// src/util/incentives-collection-views.ts
var IncentivesCollectionViewMap = (_obj = {}, _define_property(_obj, "default" /* Default */ , {
    hideHeaderTitle: false,
    hideHeaderSubtitle: false,
    hideHeaderDescription: false,
    hideSummary: false,
    hideTermsAndConditions: false
}), _define_property(_obj, "headerTitleOnly" /* HeaderTitleOnly */ , {
    hideHeaderTitle: false,
    hideSummary: true,
    hideHeaderSubtitle: true,
    hideHeaderDescription: true,
    hideTermsAndConditions: true
}), _define_property(_obj, "summaryOnly" /* SummaryOnly */ , {
    hideHeaderTitle: true,
    hideSummary: false,
    hideHeaderSubtitle: true,
    hideHeaderDescription: true,
    hideTermsAndConditions: true
}), _obj);
// src/components/collection/__private/__fragments/incentives-collection-success.tsx
import React39 from "react";
import { gql as gql39 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex13, EGDSLayoutFlexItem as EGDSLayoutFlexItem12 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing17 } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/incentives-hero-tiles-body/incentives-hero-tiles-body.tsx
import React28 from "react";
import { gql as gql28 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
// ../internal/src/components/incentives-hero-tile/incentives-hero-tile.tsx
import React26 from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
// ../internal/src/components/incentives-offer-tile/incentives-offer-tile.tsx
import React24 from "react";
import { gql as gql24 } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing6, EGDSSpacingHr } from "@egds/react-core/spacing";
import { EGDSText as EGDSText8 } from "@egds/react-core/text";
import { EgClickstreamImpressionTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-badge/egds-badge.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSBadge, EGDSBadgeLoyalty, EGDSBadgeStandard } from "@egds/react-core/badge";
import { EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
// ../internal/src/components/egds-badge/__private/badge-size-mapper.tsx
import { EGDSBadgeSize } from "@egds/react-core/badge";
var _obj1;
var BadgeSizeMapper = (_obj1 = {}, _define_property(_obj1, EGDSBadgeSize.SMALL, "small"), _define_property(_obj1, EGDSBadgeSize.LARGE, "large"), _obj1);
// ../internal/src/components/egds-badge/__private/badge-theme-mapper.tsx
import { EGDSBadgeLoyaltyThemes, EGDSBadgeStandardThemes, EGDSBadgeTheme } from "@egds/react-core/badge";
var _obj2;
var BadgeThemeMapper = (_obj2 = {}, _define_property(_obj2, EGDSBadgeTheme.DEAL_BUNDLED, "deal-bundled"), _define_property(_obj2, EGDSBadgeTheme.DEAL_GENERIC, "deal-generic"), _define_property(_obj2, EGDSBadgeTheme.DEAL_MEMBER, "deal-member"), _define_property(_obj2, EGDSBadgeTheme.NOTIFICATION_1, "notification-1"), _define_property(_obj2, EGDSBadgeTheme.NOTIFICATION_2, "notification-2"), _define_property(_obj2, EGDSBadgeTheme.VIP, "vip"), _define_property(_obj2, EGDSBadgeTheme.LOYALTY_EXTRA_HIGH_TIER, "loyalty-extra-high-tier"), _define_property(_obj2, EGDSBadgeTheme.LOYALTY_HIGH_TIER, "loyalty_high_tier"), _define_property(_obj2, EGDSBadgeTheme.LOYALTY_MIDDLE_TIER, "loyalty_middle_tier"), _define_property(_obj2, EGDSBadgeTheme.LOYALTY_LOW_TIER, "loyalty_low_tier"), _define_property(_obj2, EGDSBadgeTheme.SPONSORED, "sponsored"), _define_property(_obj2, EGDSBadgeTheme.VIEWED, "viewed"), _define_property(_obj2, EGDSBadgeTheme.SAVED, "saved"), _define_property(_obj2, EGDSBadgeTheme.FAMILY_FRIENDLY, "family-friendly"), _define_property(_obj2, EGDSBadgeTheme.SUPPLIER_PROMO, "supplier-promo"), _define_property(_obj2, EGDSBadgeTheme.PROMOTED, "promoted"), _obj2);
var StandardBadgeThemeMapper = {
    standard: EGDSBadgeStandardThemes.STANDARD,
    emphasis: EGDSBadgeStandardThemes.EMPHASIS,
    info: EGDSBadgeStandardThemes.INFO,
    featured: EGDSBadgeStandardThemes.FEATURED,
    brand: EGDSBadgeStandardThemes.BRAND,
    warning: EGDSBadgeStandardThemes.WARNING,
    positive: EGDSBadgeStandardThemes.POSITIVE
};
var LoyaltyBadgeThemeMapper = {
    lowtier: EGDSBadgeLoyaltyThemes.LOW,
    midtier: EGDSBadgeLoyaltyThemes.MID,
    hightier: EGDSBadgeLoyaltyThemes.HIGH,
    extrahightier: EGDSBadgeLoyaltyThemes.EXTRAHIGH,
    "global-standardtier": EGDSBadgeLoyaltyThemes.GLOBAL_STANDARD,
    "global-lowtier": EGDSBadgeLoyaltyThemes.GLOBAL_LOW,
    "global-middletier": EGDSBadgeLoyaltyThemes.GLOBAL_MIDDLE,
    "global-hightier": EGDSBadgeLoyaltyThemes.GLOBAL_HIGH,
    "global-extrahightier": EGDSBadgeLoyaltyThemes.GLOBAL_EXTRAHIGH
};
// ../internal/src/components/ui-graphic/ui-graphic.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
// ../internal/src/components/ui-graphic/icon.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
var fragment4 = gql10(_templateObject9());
var Icon = function(param) {
    var data = param.data, size = param.size;
    var description = data.description, id = data.id;
    return id ? /* @__PURE__ */ React10.createElement(EGDSIcon, {
        name: id,
        id: id,
        title: description,
        description: description,
        size: size || EGDSIconSize.SMALL
    }) : null;
};
Icon.fragment = fragment4;
Icon.displayName = "Icon";
// ../internal/src/components/ui-graphic/illustration.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSIllustrations } from "@egds/react-core/illustrations";
var fragment5 = gql11(_templateObject10());
var Illustration = function(param) {
    var data = param.data;
    var description = data.description, illustrationUrl = data.illustrationUrl;
    return illustrationUrl ? /* @__PURE__ */ React11.createElement(EGDSIllustrations, {
        alt: description,
        url: illustrationUrl
    }) : null;
};
Illustration.displayName = "Illustration";
Illustration.fragment = fragment5;
// ../internal/src/components/ui-graphic/mark.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
var fragment6 = gql12(_templateObject11());
var Mark = function(param) {
    var data = param.data, size = param.size;
    var description = data.description, id = data.id, url = data.url;
    return url ? /* @__PURE__ */ React12.createElement(EGDSMark, {
        description: description,
        id: id,
        size: size || EGDSMarkSize.SMALL,
        url: url.value
    }) : null;
};
Mark.displayName = "Mark";
Mark.fragment = fragment6;
// ../internal/src/components/ui-graphic/ui-graphic.tsx
var fragment7 = gql13(_templateObject12(), Icon.fragment, Mark.fragment, Illustration.fragment);
var UIGraphic = function(param) {
    var data = param.data, iconProps2 = param.iconProps, markProps = param.markProps;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React13.createElement(Icon, {
                data: data,
                size: iconProps2 === null || iconProps2 === void 0 ? void 0 : iconProps2.size
            });
        case "Mark":
            return /* @__PURE__ */ React13.createElement(Mark, {
                data: data,
                size: markProps === null || markProps === void 0 ? void 0 : markProps.size
            });
        case "Illustration":
            return /* @__PURE__ */ React13.createElement(Illustration, {
                data: data
            });
        default:
            return null;
    }
};
UIGraphic.fragment = fragment7;
UIGraphic.displayName = "UIGraphic";
// ../internal/src/components/egds-badge/egds-badge.tsx
var fragment8 = gql14(_templateObject13(), UIGraphic.fragment);
var iconProps = {
    size: EGDSIconSize2.SMALL
};
var Badge = function(param) {
    var className = param.className, data = param.data;
    var text = data.text, theme = data.theme, graphic = data.graphic, size = data.size;
    var badgeProps = React14.useMemo(function() {
        return {
            text: text !== null && text !== void 0 ? text : void 0,
            className: className !== null && className !== void 0 ? className : void 0,
            theme: theme ? BadgeThemeMapper[theme] || StandardBadgeThemeMapper[theme] || LoyaltyBadgeThemeMapper[theme] : void 0,
            size: size ? BadgeSizeMapper[size] : void 0
        };
    }, [
        text,
        className,
        theme,
        size
    ]);
    if (LoyaltyBadgeThemeMapper[badgeProps.theme]) {
        return /* @__PURE__ */ React14.createElement(EGDSBadgeLoyalty, _object_spread({}, badgeProps), graphic && /* @__PURE__ */ React14.createElement(UIGraphic, {
            data: graphic,
            iconProps: iconProps
        }));
    }
    if (StandardBadgeThemeMapper[badgeProps.theme]) {
        return /* @__PURE__ */ React14.createElement(EGDSBadgeStandard, _object_spread({}, badgeProps), graphic && /* @__PURE__ */ React14.createElement(UIGraphic, {
            data: graphic,
            iconProps: iconProps
        }));
    }
    return /* @__PURE__ */ React14.createElement(EGDSBadge, _object_spread({}, badgeProps), graphic && /* @__PURE__ */ React14.createElement(UIGraphic, {
        data: graphic,
        iconProps: iconProps
    }));
};
Badge.fragment = fragment8;
Badge.displayName = "Badge";
// ../internal/src/components/egds-text/egds-text.tsx
import React21 from "react";
import { gql as gql21 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-heading.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
var fragment9 = gql15(_templateObject14());
var Heading = function(param) {
    var className = param.className, size = param.size, tag = param.tag, data = param.data, align = param.align;
    var text = data.text;
    return /* @__PURE__ */ React15.createElement(EGDSHeading2, {
        className: className,
        tag: tag,
        size: size,
        align: align
    }, text);
};
Heading.fragment = fragment9;
Heading.displayName = "Heading";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSParagraph } from "@egds/react-core/text";
var fragment10 = gql16(_templateObject15());
var Paragraph = function(param) {
    var className = param.className, data = param.data, size = param.size;
    var text = data.text;
    return /* @__PURE__ */ React16.createElement(EGDSParagraph, {
        className: className,
        size: size
    }, text);
};
Paragraph.fragment = fragment10;
Paragraph.displayName = "Paragraph";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React17 from "react";
import { gql as gql17 } from "@apollo/client";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
var fragment11 = gql17(_templateObject16());
var PlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, data = param.data, align = param.align;
    var text = data.text;
    return /* @__PURE__ */ React17.createElement(EGDSText3, {
        className: className,
        inline: inline,
        size: size,
        align: align
    }, text);
};
PlainText.fragment = fragment11;
PlainText.displayName = "PlainText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React20 from "react";
import { gql as gql20 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
import React19 from "react";
import { gql as gql19 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React18 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
var _obj3;
// ../internal/src/components/egds-text/__private/text-theme-mapper.ts
var textThemeMapper = (_obj3 = {}, _define_property(_obj3, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj3, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj3, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj3, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj3, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj3, "INVERSE" /* INVERSE */ , "inverse"), _define_property(_obj3, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _obj3);
var _obj4;
// ../internal/src/components/egds-text/__private/text-weight-mapper.ts
var textWeightMapper = (_obj4 = {}, _define_property(_obj4, "BOLD" /* BOLD */ , "bold"), _define_property(_obj4, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj4, "REGULAR" /* REGULAR */ , "regular"), _obj4);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment12 = gql18(_templateObject17());
var StylizedText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, stylizedTextSize = param.stylizedTextSize, data = param.data, align = param.align;
    var decorative = data.decorative, text = data.text, theme = data.theme, weight = data.weight;
    var themeProps = theme ? textThemeMapper[theme] : void 0;
    var weightProps = weight ? textWeightMapper[weight] : void 0;
    var renderText = React18.useCallback(function(textSize) {
        return /* @__PURE__ */ React18.createElement(EGDSText4, {
            className: className,
            inline: inline,
            size: textSize,
            align: align,
            theme: themeProps,
            weight: weightProps
        }, text);
    }, [
        align,
        className,
        inline,
        text,
        themeProps,
        weightProps
    ]);
    switch(decorative){
        case "SUBSCRIPT" /* SUBSCRIPT */ :
            return /* @__PURE__ */ React18.createElement("sub", null, renderText(200));
        case "SUPERSCRIPT" /* SUPERSCRIPT */ :
            return /* @__PURE__ */ React18.createElement("sup", null, renderText(200));
        default:
            return renderText(stylizedTextSize !== null && stylizedTextSize !== void 0 ? stylizedTextSize : size);
    }
};
StylizedText.fragment = fragment12;
StylizedText.displayName = "StylizedText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
var fragment13 = gql19(_templateObject18(), StylizedText.fragment, PlainText.fragment);
var SpannableTextContent = function(param) {
    var className = param.className, size = param.size, stylizedTextSize = param.stylizedTextSize, data = param.data, inline = param.inline, align = param.align;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React19.createElement(StylizedText, {
                className: className,
                data: data,
                size: size,
                stylizedTextSize: stylizedTextSize,
                inline: inline,
                align: align
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React19.createElement(PlainText, {
                className: className,
                data: data,
                size: size,
                inline: inline,
                align: align
            });
        default:
            return null;
    }
};
SpannableTextContent.fragment = fragment13;
SpannableTextContent.displayName = "SpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment14 = gql20(_templateObject19(), SpannableTextContent.fragment);
var SpannableSpacing = {
    margin: {
        inlineend: "one"
    }
};
var SpannableText = function(props) {
    var data = props.data, styleProps = _object_without_properties(props, [
        "data"
    ]);
    if (data.contents.length === 0) {
        return /* @__PURE__ */ React20.createElement(EGDSText5, _object_spread({}, styleProps), data.text);
    }
    return /* @__PURE__ */ React20.createElement("div", {
        className: styleProps.className
    }, data.contents.map(function(item, index) {
        return /* @__PURE__ */ React20.createElement(EGDSSpacing4, {
            key: "spannable-item-".concat(index),
            margin: SpannableSpacing.margin
        }, /* @__PURE__ */ React20.createElement(SpannableTextContent, _object_spread({
            data: item
        }, styleProps)));
    }));
};
SpannableText.fragment = fragment14;
SpannableText.displayName = "SpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment15 = gql21(_templateObject20(), PlainText.fragment, StylizedText.fragment, SpannableText.fragment, Heading.fragment, Paragraph.fragment);
var Text = function(param) {
    var className = param.className, inline = param.inline, textSize = param.textSize, headingSize = param.headingSize, tag = param.tag, align = param.align, data = param.data, paragraphSize = param.paragraphSize;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React21.createElement(PlainText, {
                className: className,
                size: textSize,
                data: data,
                inline: inline
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React21.createElement(StylizedText, {
                className: className,
                size: textSize,
                data: data,
                inline: inline
            });
        case "EGDSSpannableText":
            return /* @__PURE__ */ React21.createElement(SpannableText, {
                className: className,
                size: textSize,
                data: data,
                inline: inline
            });
        case "EGDSParagraph":
            return /* @__PURE__ */ React21.createElement(Paragraph, {
                className: className,
                data: data,
                size: paragraphSize
            });
        case "EGDSHeading":
            return /* @__PURE__ */ React21.createElement(Heading, {
                className: className,
                size: headingSize,
                data: data,
                align: align,
                tag: tag
            });
        default:
            return null;
    }
};
Text.fragment = fragment15;
Text.displayName = "Text";
// ../internal/src/components/incentives-offer-tile-option/incentives-offer-tile-option.tsx
import React23 from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText7 } from "@egds/react-core/text";
// ../internal/src/components/egds-graphic-text/egds-graphic-text.tsx
import React22 from "react";
import { gql as gql22 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
var fragment16 = gql22(_templateObject21(), UIGraphic.fragment);
var GraphicText = function(param) {
    var data = param.data, textSize = param.textSize, iconProps2 = param.iconProps, markProps = param.markProps;
    var text = data.text, graphic = data.graphic;
    return /* @__PURE__ */ React22.createElement(EGDSLayoutFlex2, {
        space: "one",
        wrap: "wrap",
        alignItems: "center"
    }, /* @__PURE__ */ React22.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */ React22.createElement(UIGraphic, {
        data: graphic,
        iconProps: iconProps2,
        markProps: markProps
    })), /* @__PURE__ */ React22.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */ React22.createElement(EGDSText6, {
        size: textSize
    }, text)));
};
GraphicText.fragment = fragment16;
GraphicText.displayName = "GraphicText";
// ../internal/src/components/incentives-offer-tile-option/incentives-offer-tile-option.tsx
var __fragment6 = gql23(_templateObject22(), GraphicText.fragment, Badge.fragment, SpannableText.fragment);
var flexSpacing = {
    margin: {
        blockstart: "one"
    }
};
var IncentivesOfferTileOption = function(param) {
    var data = param.data, className = param.className;
    var info = data.info, time = data.time, badge = data.badge, origin = data.origin, destination = data.destination;
    return /* @__PURE__ */ React23.createElement("div", {
        className: className
    }, /* @__PURE__ */ React23.createElement(EGDSLayoutFlex3, {
        space: "two",
        wrap: "wrap",
        alignContent: "center",
        alignItems: "stretch",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React23.createElement(EGDSLayoutFlexItem3, {
        alignSelf: "start"
    }, /* @__PURE__ */ React23.createElement(GraphicText, {
        data: info,
        textSize: 200
    })), /* @__PURE__ */ React23.createElement(EGDSLayoutFlexItem3, {
        alignSelf: "start"
    }, /* @__PURE__ */ React23.createElement(EGDSText7, {
        size: 200
    }, badge.text))), /* @__PURE__ */ React23.createElement(EGDSSpacing5, {
        margin: flexSpacing.margin
    }, /* @__PURE__ */ React23.createElement(EGDSLayoutFlex3, {
        space: "two",
        wrap: "wrap",
        alignContent: "center",
        alignItems: "stretch"
    }, /* @__PURE__ */ React23.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */ React23.createElement(Text, {
        data: time,
        textSize: 400,
        inline: true
    })))), /* @__PURE__ */ React23.createElement(EGDSSpacing5, {
        margin: flexSpacing.margin
    }, /* @__PURE__ */ React23.createElement(EGDSLayoutFlex3, {
        space: "one",
        wrap: "nowrap"
    }, /* @__PURE__ */ React23.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */ React23.createElement(EGDSText7, {
        size: 300,
        overflow: "truncate"
    }, String(origin.text), " - ", String(destination.text))))));
};
IncentivesOfferTileOption.displayName = "IncentivesOfferTileOption";
IncentivesOfferTileOption.fragment = __fragment6;
// ../internal/src/components/incentives-offer-tile/incentives-offer-tile.tsx
var __fragment7 = gql24(_templateObject23(), IncentivesOfferTileOption.fragment, SpannableText.fragment, IncentivesActionLink.fragment, Badge.fragment);
var tileOptionSpacing = {
    padding: {
        blockstart: "three",
        inline: "three"
    }
};
var badgeSpacing = {
    padding: {
        inline: "three"
    }
};
var timeStampSpacing = {
    padding: {
        inline: "three",
        blockend: "three"
    }
};
var IncentivesOfferTile = function(param) {
    var data = param.data, className = param.className;
    var options = data.options, price = data.price, cardLink = data.cardLink, badge = data.badge, timeFoundAgo = data.timeFoundAgo;
    var tileOptions = React24.useMemo(function() {
        return options.map(function(tileOption, i) {
            var keyId = tileOption.time.text;
            return /* @__PURE__ */ React24.createElement("div", {
                key: "incentives-tile-option-".concat(keyId)
            }, /* @__PURE__ */ React24.createElement(IncentivesOfferTileOption, {
                data: tileOption
            }), i < options.length - 1 && /* @__PURE__ */ React24.createElement(EGDSSpacingHr, null));
        });
    }, [
        options
    ]);
    var offerTile = /* @__PURE__ */ React24.createElement(EGDSLayoutFlex4, {
        blockSize: "full_size"
    }, /* @__PURE__ */ React24.createElement(EGDSLayoutFlexItem4, {
        grow: 1
    }, /* @__PURE__ */ React24.createElement(EGDSCard, {
        border: true,
        className: className
    }, /* @__PURE__ */ React24.createElement(EGDSCardLink, null, /* @__PURE__ */ React24.createElement(IncentivesActionLink, {
        data: cardLink,
        visuallyHidden: true
    })), /* @__PURE__ */ React24.createElement(EGDSSpacing6, {
        padding: tileOptionSpacing.padding
    }, /* @__PURE__ */ React24.createElement("div", null, tileOptions)), /* @__PURE__ */ React24.createElement(EGDSCardContentSection, null, /* @__PURE__ */ React24.createElement(SpannableText, {
        data: price,
        size: 200,
        stylizedTextSize: 500,
        align: "right"
    })), badge && timeFoundAgo && /* @__PURE__ */ React24.createElement(React24.Fragment, null, /* @__PURE__ */ React24.createElement(EGDSSpacing6, {
        padding: badgeSpacing.padding
    }, /* @__PURE__ */ React24.createElement(EGDSLayoutFlex4, {
        justifyContent: "end",
        wrap: "wrap"
    }, /* @__PURE__ */ React24.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */ React24.createElement(Badge, {
        data: badge
    })))), /* @__PURE__ */ React24.createElement(EGDSSpacing6, {
        padding: timeStampSpacing.padding
    }, /* @__PURE__ */ React24.createElement(EGDSText8, {
        align: "right",
        spacing: "two",
        size: 100,
        weight: "regular"
    }, timeFoundAgo))))));
    if (cardLink.presentedAnalytics) {
        return /* @__PURE__ */ React24.createElement(EgClickstreamImpressionTracker, {
            eventData: buildClickstreamAnalyticsEvent(cardLink.presentedAnalytics)
        }, offerTile);
    }
    return offerTile;
};
IncentivesOfferTile.fragment = __fragment7;
IncentivesOfferTile.displayName = "IncentivesOfferTile";
// ../internal/src/components/incentives-tile-content/incentives-tile-content.tsx
import React25 from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSParagraph as EGDSParagraph2, EGDSSubheading } from "@egds/react-core/text";
var __fragment8 = gql25(_templateObject24());
var defaultMargin = {
    blockstart: "one"
};
var IncentivesTileContent = function(param) {
    var data = param.data, _param_descriptionProps = param.descriptionProps, descriptionProps = _param_descriptionProps === void 0 ? {} : _param_descriptionProps, _param_titleProps = param.titleProps, titleProps = _param_titleProps === void 0 ? {} : _param_titleProps, _param_subTitleProps = param.subTitleProps, subTitleProps = _param_subTitleProps === void 0 ? {} : _param_subTitleProps, className = param.className, _param_isDescriptionHidden = param.isDescriptionHidden, isDescriptionHidden = _param_isDescriptionHidden === void 0 ? false : _param_isDescriptionHidden, _param_isPaddedCard = param.isPaddedCard, isPaddedCard = _param_isPaddedCard === void 0 ? false : _param_isPaddedCard;
    var title = data.title, subTitle = data.subTitle, description = data.description;
    return /* @__PURE__ */ React25.createElement(EGDSLayoutFlex5, {
        direction: "column",
        className: className
    }, /* @__PURE__ */ React25.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */ React25.createElement(EGDSSpacing7, {
        margin: titleProps.margin || defaultMargin,
        padding: titleProps.padding
    }, /* @__PURE__ */ React25.createElement(EGDSHeading3, {
        overflow: titleProps === null || titleProps === void 0 ? void 0 : titleProps.overflow,
        size: titleProps.size,
        tag: titleProps.tag,
        style: {
            minHeight: isPaddedCard ? "2.5rem" : ""
        }
    }, title))), subTitle && /* @__PURE__ */ React25.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */ React25.createElement(EGDSSpacing7, {
        margin: subTitleProps.margin || defaultMargin,
        padding: subTitleProps.padding
    }, /* @__PURE__ */ React25.createElement(EGDSSubheading, {
        tag: subTitleProps.tag || "h4",
        overflow: titleProps === null || titleProps === void 0 ? void 0 : titleProps.overflow
    }, subTitle))), !isDescriptionHidden && description && /* @__PURE__ */ React25.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */ React25.createElement(EGDSSpacing7, {
        margin: descriptionProps.margin || defaultMargin,
        padding: descriptionProps.padding
    }, /* @__PURE__ */ React25.createElement("div", null, /* @__PURE__ */ React25.createElement(EGDSParagraph2, {
        size: descriptionProps.size || 3,
        className: descriptionProps.className
    }, description)))));
};
IncentivesTileContent.fragment = __fragment8;
IncentivesTileContent.displayName = "IncentivesTileContent";
// ../internal/src/components/incentives-hero-tile/incentives-hero-tile.tsx
var __fragment9 = gql26(_templateObject25(), IncentivesTileContent.fragment, IncentivesActionLink.fragment, IncentivesOfferTile.fragment);
var incentivesTileContentSpacings = {
    margin: {
        blockstart: "six"
    }
};
var tilesSpacing = {
    margin: {
        blockstart: "six"
    }
};
var getTileContentProps = function(tag) {
    return {
        titleProps: {
            size: 4,
            tag: tag || "h3",
            margin: "unset"
        },
        descriptionProps: {
            size: 1
        }
    };
};
var IncentivesHeroTile = function(param) {
    var data = param.data, heroTileSpacing = param.heroTileSpacing, headingTag = param.headingTag;
    var offers = data.offers, content = data.content, action = data.action;
    var resource = action.resource;
    var buttonClickHandler = React26.useCallback(function() {
        window.open(resource.value, "_self");
    }, [
        action
    ]);
    if (offers.length === 0) {
        return null;
    }
    var tileContentProps = getTileContentProps(headingTag);
    return /* @__PURE__ */ React26.createElement(EGDSSpacing8, {
        margin: heroTileSpacing
    }, /* @__PURE__ */ React26.createElement("div", null, /* @__PURE__ */ React26.createElement(EGDSSpacing8, {
        margin: incentivesTileContentSpacings.margin
    }, /* @__PURE__ */ React26.createElement(IncentivesTileContent, {
        data: content,
        titleProps: tileContentProps.titleProps,
        descriptionProps: tileContentProps.descriptionProps
    })), /* @__PURE__ */ React26.createElement(EGDSSpacing8, {
        margin: tilesSpacing.margin
    }, /* @__PURE__ */ React26.createElement(EGDSLayoutGrid, {
        columns: {
            small: 1,
            medium: 2,
            large: 3,
            extra_large: 4
        },
        space: {
            column: "three",
            row: "three"
        }
    }, offers.map(function(offer, i) {
        return /* @__PURE__ */ React26.createElement(EGDSLayoutGridItem, {
            key: "offer-tile-".concat(i)
        }, /* @__PURE__ */ React26.createElement(IncentivesOfferTile, {
            data: offer
        }));
    }))), /* @__PURE__ */ React26.createElement(EGDSSpacing8, {
        margin: tilesSpacing.margin
    }, /* @__PURE__ */ React26.createElement(IncentivesActionLink, {
        data: action,
        buttonClickHandler: buttonClickHandler
    }))));
};
IncentivesHeroTile.displayName = "IncentivesHeroTile";
IncentivesHeroTile.fragment = __fragment9;
// ../internal/src/components/incentives-results-summary/incentives-results-summary.tsx
import React27 from "react";
import { gql as gql27 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText9 } from "@egds/react-core/text";
var __fragment10 = gql27(_templateObject26(), SpannableText.fragment);
var IncentivesResultsSummary = function(param) {
    var data = param.data, _param_textSize = param.textSize, textSize = _param_textSize === void 0 ? 300 : _param_textSize;
    var dealsDate = data.dealsDate, message = data.message;
    return /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(Text, {
        textSize: textSize,
        data: dealsDate,
        inline: true
    }), message && /* @__PURE__ */ React27.createElement(EGDSSpacing9, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React27.createElement(EGDSText9, {
        size: 200
    }, message)));
};
IncentivesResultsSummary.displayName = "IncentivesResultsSummary";
IncentivesResultsSummary.fragment = __fragment10;
// ../internal/src/components/incentives-hero-tiles-body/incentives-hero-tiles-body.tsx
var __fragment11 = gql28(_templateObject27(), IncentivesHeroTile.fragment, IncentivesResultsSummary.fragment);
var bodySpacingLayer = {
    margin: {
        blockstart: "six"
    },
    padding: {
        blockstart: "two"
    }
};
var multipleHeaderBodySpacingLayer = {
    padding: {
        blockstart: "unset"
    }
};
var listBlockendSpacing = {
    margin: {
        blockstart: "twelve"
    }
};
var firstBlockSpacing = {
    margin: {
        blockstart: "six"
    }
};
var selectMarginByIndex = function(index) {
    return index === 0 ? firstBlockSpacing.margin : listBlockendSpacing.margin;
};
var IncentivesHeroTilesBody = function(param) {
    var data = param.data, _param_multipleHeader = param.multipleHeader, multipleHeader = _param_multipleHeader === void 0 ? false : _param_multipleHeader;
    var heroTiles = data.heroTiles, heroSummary = data.heroSummary;
    if (heroTiles.length === 0) {
        return null;
    }
    var headingTag = multipleHeader ? "h3" : "h2";
    return /* @__PURE__ */ React28.createElement(EGDSSpacing10, {
        margin: bodySpacingLayer.margin,
        padding: multipleHeader ? multipleHeaderBodySpacingLayer.padding : bodySpacingLayer.padding
    }, /* @__PURE__ */ React28.createElement("div", null, heroSummary && /* @__PURE__ */ React28.createElement(IncentivesResultsSummary, {
        data: heroSummary
    }), /* @__PURE__ */ React28.createElement(EGDSLayoutFlex6, {
        direction: "column"
    }, heroTiles === null || heroTiles === void 0 ? void 0 : heroTiles.map(function(item, index) {
        return /* @__PURE__ */ React28.createElement(Viewport4, {
            key: "collection-content-item-".concat(index)
        }, /* @__PURE__ */ React28.createElement(ViewMedium4, null, /* @__PURE__ */ React28.createElement(EGDSLayoutFlexItem6, {
            minWidth: "third_width"
        }, /* @__PURE__ */ React28.createElement(IncentivesHeroTile, {
            data: item,
            heroTileSpacing: selectMarginByIndex(index),
            headingTag: headingTag
        }))), /* @__PURE__ */ React28.createElement(ViewSmall4, null, /* @__PURE__ */ React28.createElement(EGDSLayoutFlexItem6, {
            minWidth: "full_width"
        }, /* @__PURE__ */ React28.createElement(IncentivesHeroTile, {
            data: item,
            heroTileSpacing: selectMarginByIndex(index),
            headingTag: headingTag
        }))));
    }))));
};
IncentivesHeroTilesBody.fragment = __fragment11;
IncentivesHeroTilesBody.displayName = "IncentivesHeroTilesBody";
// ../internal/src/components/incentives-media-tiles-body/incentives-media-tiles-body.tsx
import React36 from "react";
import { gql as gql36 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSLoader } from "@egds/react-core/loader";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
// ../internal/src/components/incentives-load-more-button/incentives-load-more-button.tsx
import React29 from "react";
import { gql as gql29 } from "@apollo/client";
import { useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
var __fragment12 = gql29(_templateObject28(), CollectionClickstreamAnalyticsFragment, Button.fragment);
var IncentivesLoadMoreButton = function(param) {
    var data = param.data, fetchMorePagination = param.fetchMorePagination;
    var button = data.button, selectedAnalytics = data.selectedAnalytics;
    var track = useEgClickstream3();
    var onClick = function() {
        fetchMorePagination();
        if (selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(selectedAnalytics));
        }
    };
    return /* @__PURE__ */ React29.createElement(Button, {
        data: button,
        onClickHandler: onClick
    });
};
IncentivesLoadMoreButton.fragment = __fragment12;
IncentivesLoadMoreButton.displayName = "IncentivesLoadMoreButton";
// ../internal/src/components/incentives-media-tile/incentives-media-tile.tsx
import React35 from "react";
import { gql as gql35 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2 } from "@egds/react-core/button";
import { EGDSCard as EGDSCard3, EGDSCardContentSection as EGDSCardContentSection3, EGDSCardLink as EGDSCardLink2 } from "@egds/react-core/cards";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType3 } from "@egds/react-core/images";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker2, useClickTracker as useClickTracker3, useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/incentives-media/incentives-media.tsx
import React32 from "react";
import { gql as gql32 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
// ../internal/src/components/egds-gallery-carousel/egds-gallery-carousel.tsx
import React31 from "react";
import { gql as gql31 } from "@apollo/client";
import { EGDSButtonTheme } from "@egds/react-core/button";
import { EGDSCard as EGDSCard2, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSGalleryCarousel } from "@egds/react-core/gallery-carousel";
// ../internal/src/components/egds-media-item/egds-media-item.tsx
import React30 from "react";
import { gql as gql30 } from "@apollo/client";
var fragment17 = gql30(_templateObject29(), Image.fragment);
var MediaItem = function(param) {
    var data = param.data;
    switch(data.media.__typename){
        case "Image":
            return /* @__PURE__ */ React30.createElement(Image, {
                data: data.media
            });
        default:
            return null;
    }
};
MediaItem.fragment = fragment17;
MediaItem.displayName = "MediaItem";
// ../internal/src/components/egds-gallery-carousel/__private/get-images-prop-from-data.ts
var getImagesPropFromData = function(media) {
    return media.reduce(function(acc, curr) {
        if (curr.media.__typename === "Image") {
            acc.push({
                src: curr.media.url,
                alt: curr.media.description
            });
        }
        return acc;
    }, []);
};
// ../internal/src/components/egds-gallery-carousel/egds-gallery-carousel.tsx
var fragment18 = gql31(_templateObject30(), MediaItem.fragment);
var GalleryCarousel = function(param) {
    var data = param.data, carouselId = param.carouselId, allyHeadingLevel = param.allyHeadingLevel, ratio = param.ratio, onImageClick = param.onImageClick, _param_roundedCorners = param.roundedCorners, roundedCorners = _param_roundedCorners === void 0 ? false : _param_roundedCorners;
    var media = data.media, accessibilityHeadingText = data.accessibilityHeadingText;
    if (media.length === 0 || media.find(function(item) {
        return item.media.__typename === "Video";
    })) {
        return null;
    }
    var buttonText = data.nextButtonText && data.previousButtonText ? {
        nextButton: data.nextButtonText,
        prevButton: data.previousButtonText
    } : void 0;
    var images = getImagesPropFromData(media);
    var carousel = /* @__PURE__ */ React31.createElement(EGDSCardContentSection2, {
        padded: false
    }, /* @__PURE__ */ React31.createElement(EGDSGalleryCarousel, {
        ratio: ratio,
        allyHeadingText: accessibilityHeadingText,
        allyHeadingLevel: allyHeadingLevel !== null && allyHeadingLevel !== void 0 ? allyHeadingLevel : void 0,
        carouselId: carouselId,
        carouselName: carouselId,
        buttonText: buttonText,
        images: images,
        navTheme: EGDSButtonTheme.TRANSPARENT,
        showGalleryButton: false,
        onImageClick: onImageClick,
        placeholderImage: true,
        enablePreload: true
    }));
    return roundedCorners ? /* @__PURE__ */ React31.createElement(EGDSCard2, null, carousel) : carousel;
};
GalleryCarousel.fragment = fragment18;
GalleryCarousel.displayName = "GalleryCarousel";
// ../internal/src/components/incentives-media/incentives-media.tsx
var __fragment13 = gql32(_templateObject31(), GalleryCarousel.fragment, Badge.fragment);
var badgeSpacing2 = {
    margin: {
        inlineend: "two"
    }
};
var badgePosition = {
    position: {
        top: "four",
        left: "three",
        zindex: "layer2"
    }
};
var IncentivesMedia = function(param) {
    var data = param.data, allyHeadingLevel = param.allyHeadingLevel, carouselId = param.carouselId, ratio = param.ratio, onImageClick = param.onImageClick, _param_roundedCorners = param.roundedCorners, roundedCorners = _param_roundedCorners === void 0 ? false : _param_roundedCorners;
    var gallery = data.gallery, badges = data.badges;
    return /* @__PURE__ */ React32.createElement(EGDSLayoutPosition, {
        type: "relative"
    }, /* @__PURE__ */ React32.createElement(GalleryCarousel, {
        carouselId: carouselId,
        allyHeadingLevel: allyHeadingLevel,
        ratio: ratio,
        onImageClick: onImageClick,
        data: gallery,
        roundedCorners: roundedCorners
    }), /* @__PURE__ */ React32.createElement(EGDSLayoutPosition, {
        type: "absolute",
        position: badgePosition.position
    }, /* @__PURE__ */ React32.createElement(EGDSLayoutFlex7, null, badges.map(function(item, index) {
        return /* @__PURE__ */ React32.createElement(EGDSLayoutFlexItem7, {
            key: "incentives-egds-badge-".concat(index)
        }, /* @__PURE__ */ React32.createElement(EGDSSpacing11, _object_spread({}, badgeSpacing2), /* @__PURE__ */ React32.createElement(Badge, {
            data: item
        })));
    }))));
};
IncentivesMedia.displayName = "IncentivesMedia";
IncentivesMedia.fragment = __fragment13;
// ../internal/src/components/incentives-media-tile-price/incentives-media-tile-price.tsx
import React33 from "react";
import { gql as gql33 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex8 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { PriceSummary } from "@shared-ui/pricing-price-summary";
var fragment19 = gql33(_templateObject32(), Badge.fragment, PriceSummary.fragment);
var priceSpacing = {
    inlinestart: "four"
};
var IncentivesMediaTilePrice = function(param) {
    var data = param.data, className = param.className, _param_isPackages = param.isPackages, isPackages = _param_isPackages === void 0 ? false : _param_isPackages;
    var badge = data.badge, propertyPrice = data.propertyPrice;
    var direction = propertyPrice ? "column-reverse" : "row";
    var alignItems = propertyPrice ? "start" : "center";
    var padding;
    var priceComponentAlignment = "start";
    var badgeSpacing3 = {
        inlineend: "two",
        blockstart: propertyPrice ? "two" : "unset"
    };
    if (isPackages) {
        direction = propertyPrice ? "column" : "row";
        alignItems = propertyPrice ? "end" : "center";
        padding = {
            inlineend: "two"
        };
        priceComponentAlignment = "end";
        badgeSpacing3 = {
            blockstart: "two",
            blockend: "one"
        };
    }
    var priceComponent = /* @__PURE__ */ React33.createElement(React33.Fragment, null, propertyPrice && /* @__PURE__ */ React33.createElement(PriceSummary, {
        data: propertyPrice,
        flexAlignment: priceComponentAlignment
    }));
    return /* @__PURE__ */ React33.createElement(EGDSLayoutFlex8, {
        direction: direction,
        alignItems: alignItems,
        className: className,
        wrap: "wrap"
    }, badge && /* @__PURE__ */ React33.createElement(EGDSSpacing12, {
        margin: badgeSpacing3
    }, /* @__PURE__ */ React33.createElement(Badge, {
        data: badge
    })), /* @__PURE__ */ React33.createElement(EGDSSpacing12, {
        margin: priceSpacing,
        padding: padding
    }, priceComponent));
};
IncentivesMediaTilePrice.fragment = fragment19;
IncentivesMediaTilePrice.displayName = "IncentivesMediaTilePrice";
// ../internal/src/components/product-rating-summary/product-rating-summary.tsx
import React34 from "react";
import { gql as gql34 } from "@apollo/client";
import { EGDSBadgeSize as EGDSBadgeSize2, EGDSBadgeStandard as EGDSBadgeStandard2 } from "@egds/react-core/badge";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText10 } from "@egds/react-core/text";
var fragment20 = gql34(_templateObject33());
var ProductRatingSummary = function(param) {
    var data = param.data, inline = param.inline;
    var primary = data.primary, secondary = data.secondary, theme = data.theme, supportingMessages = data.supportingMessages, accessibilityLabel = data.accessibilityLabel;
    if (!primary) {
        return null;
    }
    var _theme_toLowerCase;
    var badgeTheme = (_theme_toLowerCase = theme === null || theme === void 0 ? void 0 : theme.toLowerCase()) !== null && _theme_toLowerCase !== void 0 ? _theme_toLowerCase : "standard";
    return /* @__PURE__ */ React34.createElement(EGDSLayoutFlex9, {
        alignItems: "center",
        space: "one"
    }, /* @__PURE__ */ React34.createElement(EGDSLayoutFlex9, {
        alignItems: "center"
    }, /* @__PURE__ */ React34.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */ React34.createElement(EGDSBadgeStandard2, {
        theme: badgeTheme,
        a11yText: accessibilityLabel || void 0,
        text: primary,
        size: EGDSBadgeSize2.LARGE
    }))), /* @__PURE__ */ React34.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */ React34.createElement(EGDSLayoutFlex9, {
        direction: inline ? "row" : "column",
        space: inline ? "one" : void 0,
        alignItems: inline ? "center" : void 0
    }, secondary && /* @__PURE__ */ React34.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */ React34.createElement(EGDSText10, {
        weight: "medium"
    }, secondary)), supportingMessages.map(function(item, index) {
        return item.__typename === "EGDSPlainText" && /* @__PURE__ */ React34.createElement(EGDSLayoutFlexItem8, {
            key: item.text
        }, /* @__PURE__ */ React34.createElement(EGDSText10, {
            size: 200
        }, item.text));
    }))));
};
ProductRatingSummary.fragment = fragment20;
ProductRatingSummary.displayName = "sharedui-IncentivesProductRatingSummary";
// ../internal/src/components/incentives-media-tile/constants.ts
var FoundationPadding = {
    toplineSpaceing: {
        padding: {
            blockend: "three"
        }
    },
    contentSectionSpacing: false,
    titleSpacing: {
        margin: {
            blockstart: "one"
        }
    },
    detailsSpacing: {
        margin: {
            blockstart: "two"
        }
    },
    priceSpacing: {
        margin: {
            blockstart: "three"
        }
    },
    actionButtonSpacing: {
        margin: {
            blockstart: "three"
        }
    },
    ratingSpacing: {
        margin: {
            blockstart: "three"
        }
    },
    contentProps: {
        titleProps: {
            overflow: "truncate-2-lines",
            tag: "h3"
        },
        subTitleProps: {
            tag: "h4"
        },
        descriptionProps: {
            className: "truncate-lines-3"
        }
    }
};
var PaddedCardPadding = {
    toplineSpaceing: {
        padding: {}
    },
    contentSectionSpacing: true,
    titleSpacing: {
        margin: {
            blockstart: "two"
        }
    },
    detailsSpacing: {
        margin: {
            blockstart: "two"
        }
    },
    priceSpacing: {
        margin: {
            blockstart: "two"
        }
    },
    actionButtonSpacing: {
        margin: {
            blockstart: "three"
        }
    },
    ratingSpacing: {
        margin: {}
    },
    contentProps: {
        titleProps: {
            overflow: "truncate-2-lines",
            tag: "h3"
        },
        subTitleProps: {
            tag: "h4"
        },
        descriptionProps: {
            className: "truncate-lines-3"
        }
    }
};
var clpContentProps = {
    titleProps: {
        overflow: "truncate-2-lines",
        tag: "h2"
    },
    subTitleProps: {
        tag: "h3"
    },
    descriptionProps: {
        className: "truncate-lines-3"
    }
};
// ../internal/src/components/incentives-media-tile/incentives-media-tile.tsx
var __fragment14 = gql35(_templateObject34(), IncentivesMedia.fragment, SpannableText.fragment, IncentivesActionLink.fragment, IncentivesTileContent.fragment, IncentivesMediaTilePrice.fragment);
var IncentivesMediaTile = function(param) {
    var data = param.data, _param_cardContentSize = param.cardContentSize, cardContentSize = _param_cardContentSize === void 0 ? "FOUNDATION" /* FOUNDATION */  : _param_cardContentSize, multiArmBanditTrack = param.multiArmBanditTrack, multipleHeader = param.multipleHeader;
    var _padding_toplineSpaceing, _tileContentProps_titleProps;
    var media = data.media, rating = data.rating, content = data.content, price = data.price, cardLink = data.cardLink, action = data.action, productRatingSummary = data.productRatingSummary;
    var clickTracker = useClickTracker3();
    var track = useEgClickstream4();
    var onImageClick = React35.useCallback(function() {
        multiArmBanditTrack === null || multiArmBanditTrack === void 0 ? void 0 : multiArmBanditTrack();
        clickTracker(cardLink.clickAnalytics.referrerId, cardLink.clickAnalytics.linkName);
        if (cardLink.selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(cardLink.selectedAnalytics));
        }
        window.open(cardLink.resource.value, "_self");
    }, [
        cardLink,
        track,
        clickTracker,
        multiArmBanditTrack
    ]);
    var padding = cardContentSize === "PADDED_CARD" /* PADDED_CARD */  ? PaddedCardPadding : FoundationPadding;
    var isPaddedCard = cardContentSize === "PADDED_CARD" /* PADDED_CARD */ ;
    var renderActionLinkArea = function() {
        if (action === null || action === void 0 ? void 0 : action.button) {
            return /* @__PURE__ */ React35.createElement(EGDSSpacing13, {
                margin: padding.actionButtonSpacing.margin
            }, /* @__PURE__ */ React35.createElement(IncentivesActionLink, {
                data: action,
                buttonSize: EGDSButtonSize2.SMALL,
                multiArmBanditTrack: multiArmBanditTrack
            }));
        }
        return null;
    };
    var tileContentProps = multipleHeader ? padding.contentProps : clpContentProps;
    var mediaTile = /* @__PURE__ */ React35.createElement(React35.Fragment, null, /* @__PURE__ */ React35.createElement(EGDSSpacing13, {
        padding: padding === null || padding === void 0 ? void 0 : (_padding_toplineSpaceing = padding.toplineSpaceing) === null || _padding_toplineSpaceing === void 0 ? void 0 : _padding_toplineSpaceing.padding
    }, /* @__PURE__ */ React35.createElement(EGDSCard3, {
        className: isPaddedCard ? "uitk-layout-flex-block-size-full-size" : "",
        border: isPaddedCard
    }, /* @__PURE__ */ React35.createElement(EGDSCardLink2, null, /* @__PURE__ */ React35.createElement(IncentivesActionLink, {
        data: cardLink,
        multiArmBanditTrack: multiArmBanditTrack,
        visuallyHidden: true
    })), /* @__PURE__ */ React35.createElement(IncentivesMedia, {
        carouselId: "incentives-media-tile-carousel-".concat(cardLink.clickAnalytics.referrerId),
        data: media,
        allyHeadingLevel: (_tileContentProps_titleProps = tileContentProps.titleProps) === null || _tileContentProps_titleProps === void 0 ? void 0 : _tileContentProps_titleProps.tag,
        ratio: EGDSFigureAspectRatioType3.R4_3,
        onImageClick: onImageClick,
        roundedCorners: true
    }), /* @__PURE__ */ React35.createElement(EGDSCardContentSection3, {
        padded: padding.contentSectionSpacing
    }, /* @__PURE__ */ React35.createElement(EGDSSpacing13, {
        margin: padding.ratingSpacing.margin
    }, productRatingSummary ? /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(ProductRatingSummary, {
        data: productRatingSummary,
        inline: true
    })) : rating.contents.length > 0 && /* @__PURE__ */ React35.createElement(Text, {
        textSize: 300,
        data: rating,
        inline: true
    })), /* @__PURE__ */ React35.createElement(EGDSSpacing13, {
        margin: padding.titleSpacing.margin
    }, /* @__PURE__ */ React35.createElement(IncentivesTileContent, {
        data: content,
        titleProps: tileContentProps.titleProps,
        subTitleProps: tileContentProps.subTitleProps,
        descriptionProps: tileContentProps.descriptionProps,
        isPaddedCard: isPaddedCard,
        isDescriptionHidden: true
    })), /* @__PURE__ */ React35.createElement(EGDSSpacing13, {
        margin: padding.priceSpacing.margin
    }, /* @__PURE__ */ React35.createElement(IncentivesMediaTilePrice, {
        data: price
    })), isPaddedCard && renderActionLinkArea()))), !isPaddedCard && renderActionLinkArea());
    if (cardLink.presentedAnalytics) {
        return /* @__PURE__ */ React35.createElement(EgClickstreamImpressionTracker2, {
            eventData: buildClickstreamAnalyticsEvent(cardLink.presentedAnalytics)
        }, mediaTile);
    }
    return mediaTile;
};
IncentivesMediaTile.fragment = __fragment14;
IncentivesMediaTile.displayName = "IncentivesMediaTile";
// ../internal/src/components/incentives-media-tiles-body/incentives-media-tiles-body.tsx
var __fragment15 = gql36(_templateObject35(), IncentivesMediaTile.fragment, IncentivesResultsSummary.fragment, IncentivesLoadMoreButton.fragment);
var bodySpacingLayer2 = {
    margin: {
        blockstart: "six"
    },
    padding: {
        blockstart: "two"
    }
};
var multipleHeaderBodySpacingLayer2 = {
    margin: {
        blockstart: "three"
    },
    padding: {
        blockstart: "unset"
    }
};
var gridSpacing = {
    margin: {
        blockstart: "six"
    }
};
var IncentivesMediaTilesBody = function(param) {
    var data = param.data, paginationHandler = param.paginationHandler, isLoading = param.isLoading, _param_multipleHeader = param.multipleHeader, multipleHeader = _param_multipleHeader === void 0 ? false : _param_multipleHeader;
    var tiles = data.tiles, summary = data.summary, loadMoreAction = data.loadMoreAction;
    if (tiles.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React36.createElement(EGDSSpacing14, {
        margin: bodySpacingLayer2.margin,
        padding: multipleHeader ? multipleHeaderBodySpacingLayer2.padding : bodySpacingLayer2.padding
    }, /* @__PURE__ */ React36.createElement("div", null, summary && /* @__PURE__ */ React36.createElement(IncentivesResultsSummary, {
        data: summary
    }), /* @__PURE__ */ React36.createElement(EGDSSpacing14, {
        margin: multipleHeader ? multipleHeaderBodySpacingLayer2.margin : gridSpacing.margin
    }, /* @__PURE__ */ React36.createElement("div", null, /* @__PURE__ */ React36.createElement(EGDSLayoutGrid2, {
        columns: {
            small: 1,
            medium: 3
        },
        space: {
            column: "three",
            row: "twelve"
        }
    }, tiles === null || tiles === void 0 ? void 0 : tiles.map(function(item, index) {
        return /* @__PURE__ */ React36.createElement(EGDSLayoutGridItem2, {
            key: "collection-content-item-".concat(index)
        }, /* @__PURE__ */ React36.createElement(IncentivesMediaTile, {
            data: item,
            multipleHeader: multipleHeader
        }));
    })), /* @__PURE__ */ React36.createElement(EGDSSpacing14, {
        margin: "four"
    }, /* @__PURE__ */ React36.createElement(EGDSLayoutFlex10, {
        justifyContent: "center"
    }, /* @__PURE__ */ React36.createElement(EGDSLayoutFlexItem9, null, isLoading ? /* @__PURE__ */ React36.createElement(EGDSLoader, null) : loadMoreAction && /* @__PURE__ */ React36.createElement(IncentivesLoadMoreButton, {
        data: loadMoreAction,
        fetchMorePagination: paginationHandler
    }))))))));
};
IncentivesMediaTilesBody.fragment = __fragment15;
IncentivesMediaTilesBody.displayName = "IncentivesMediaTilesBody";
// src/components/collection/__private/__fragments/incentives-collection-success.tsx
import { ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
// src/__generated__/types.ts
var CollectionItemClickthrough = /* @__PURE__ */ function(CollectionItemClickthrough2) {
    CollectionItemClickthrough2["PDP"] = "PDP";
    CollectionItemClickthrough2["PINNED_SRP"] = "PINNED_SRP";
    return CollectionItemClickthrough2;
}(CollectionItemClickthrough || {});
var CollectionType = /* @__PURE__ */ function(CollectionType2) {
    CollectionType2["FLIGHT"] = "FLIGHT";
    CollectionType2["GEOGRAPHY"] = "GEOGRAPHY";
    CollectionType2["LODGING"] = "LODGING";
    CollectionType2["PACKAGE"] = "PACKAGE";
    return CollectionType2;
}(CollectionType || {});
// src/components/utility.tsx
var getFetchMoreCallback = function(variables, paginationContext, setPaginationLoading, fetchMore) {
    return function() {
        var pageSize = paginationContext.pageSize, offset = paginationContext.offset, maxPageSize = paginationContext.maxPageSize;
        setPaginationLoading(true);
        fetchMore({
            variables: _object_spread_props(_object_spread({}, variables), {
                paginationContext: {
                    pageSize: pageSize,
                    maxPageSize: maxPageSize,
                    offset: offset
                }
            }),
            updateQuery: function(prevResult, param) {
                var fetchMoreResult = param.fetchMoreResult;
                var _fetchMoreResult_incentivesCollectionView, _fetchMoreResult_queryName, _prevResult_queryName;
                if (!fetchMoreResult) {
                    return prevResult;
                }
                var queryName = (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.incentivesCollectionView) ? "incentivesCollectionView" : "incentivesCollection";
                if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult_incentivesCollectionView = fetchMoreResult.incentivesCollectionView) === null || _fetchMoreResult_incentivesCollectionView === void 0 ? void 0 : _fetchMoreResult_incentivesCollectionView.__typename) === "IncentivesCollectionError") {
                    setPaginationLoading(false);
                    return _object_spread_props(_object_spread({}, prevResult), {
                        incentivesCollectionView: _object_spread_props(_object_spread({}, prevResult.incentivesCollectionView), {
                            collectionBody: _object_spread_props(_object_spread({}, prevResult.incentivesCollectionView.collectionBody), {
                                loadMoreAction: null
                            })
                        })
                    });
                }
                var currentBody = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult_queryName = fetchMoreResult[queryName]) === null || _fetchMoreResult_queryName === void 0 ? void 0 : _fetchMoreResult_queryName.collectionBody;
                var previousBody = prevResult === null || prevResult === void 0 ? void 0 : (_prevResult_queryName = prevResult[queryName]) === null || _prevResult_queryName === void 0 ? void 0 : _prevResult_queryName.collectionBody;
                currentBody.tiles = _to_consumable_array(previousBody.tiles).concat(_to_consumable_array(currentBody.tiles));
                setPaginationLoading(false);
                return fetchMoreResult;
            }
        });
    };
};
// src/components/collection/layout-values.ts
var gridSpacing2 = {
    column: "six",
    row: "twelve"
};
var moduleConatinerSpacing = {
    margin: {
        blockstart: "twelve"
    }
};
var itemsGridColumns = {
    small: 1,
    medium: 2
};
var collectionGridColumns = {
    small: 1,
    medium: 3
};
// src/components/collection/__private/__fragments/collection-item/incentives-content-item.tsx
import React38 from "react";
import { gql as gql38 } from "@apollo/client";
import { EGDSFigure as EGDSFigure3, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType4, EGDSImage as EGDSImage3, EGDSImageLink as EGDSImageLink2 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex12, EGDSLayoutFlexItem as EGDSLayoutFlexItem11 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading4, EGDSParagraph as EGDSParagraph3, EGDSText as EGDSText12 } from "@egds/react-core/text";
import { IntersectionTracker, useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
// src/components/collection/__private/__fragments/collection-item/incentives-action-link-button.tsx
import React37 from "react";
import { gql as gql37 } from "@apollo/client";
import { EGDSCard as EGDSCard4, EGDSCardContentSection as EGDSCardContentSection4, EGDSCardLink as EGDSCardLink3 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex11, EGDSLayoutFlexItem as EGDSLayoutFlexItem10 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText11 } from "@egds/react-core/text";
// src/components/collection/__private/__fragments/collection-item/layout-values.ts
var itemDescriptionSpacing = {
    margin: {
        blockstart: "four"
    }
};
var itemTitleSpacing = {
    margin: {
        blockstart: "six"
    }
};
var itemActionCardSpacing = {
    margin: {
        blockstart: "six"
    }
};
var itemActionContentPadded = [
    "blockstart",
    "blockend",
    "inlineend"
];
var itemActionTextPadding = {
    inlinestart: "four",
    block: "half"
};
// src/components/collection/__private/__fragments/collection-item/incentives-action-link-button.tsx
var __fragment16 = gql37(_templateObject36());
var IncentivesActionLinkButton = function(param) {
    var data = param.data, handleClickCapture = param.handleClickCapture;
    var accessibility = data.accessibility, resource = data.resource;
    if (!accessibility) {
        return null;
    }
    return /* @__PURE__ */ React37.createElement(EGDSLayoutFlex11, null, /* @__PURE__ */ React37.createElement(EGDSLayoutFlexItem10, {
        minWidth: "eighty_eight"
    }, /* @__PURE__ */ React37.createElement(EGDSCard4, {
        border: true
    }, /* @__PURE__ */ React37.createElement(EGDSCardContentSection4, {
        padded: itemActionContentPadded
    }, /* @__PURE__ */ React37.createElement(EGDSCardLink3, null, /* @__PURE__ */ React37.createElement("a", {
        href: resource.value,
        onClickCapture: handleClickCapture
    }, accessibility)), /* @__PURE__ */ React37.createElement(EGDSLayoutFlex11, {
        justifyContent: "space-between",
        alignItems: "center"
    }, /* @__PURE__ */ React37.createElement(EGDSLayoutFlexItem10, {
        maxWidth: "full_width"
    }, /* @__PURE__ */ React37.createElement(EGDSSpacing15, {
        padding: itemActionTextPadding
    }, /* @__PURE__ */ React37.createElement(EGDSText11, {
        size: 300,
        weight: "medium",
        theme: "emphasis",
        overflow: "truncate",
        "aria-hidden": true
    }, accessibility))), /* @__PURE__ */ React37.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */ React37.createElement(EGDSIcon2, {
        name: "chevron_right"
    })))))));
};
IncentivesActionLinkButton.fragment = __fragment16;
IncentivesActionLinkButton.displayName = "IncentivesActionLinkButton";
// src/components/collection/__private/__fragments/collection-item/incentives-content-item.tsx
var __fragment17 = gql38(_templateObject37(), IncentivesActionLinkButton.fragment);
var variants = {
    MEDIUM: {
        headingSize: 4,
        descriptionSize: 2,
        ratio: EGDSFigureAspectRatioType4.R4_3
    },
    LARGE: {
        headingSize: 3,
        descriptionSize: 1,
        ratio: EGDSFigureAspectRatioType4.R21_9
    }
};
var IncentivesContentItem = function(param) {
    var data = param.data, size = param.size, className = param.className, eventingDetails = param.eventingDetails;
    var incentivesImage = data.incentivesImage, title = data.title, subtitle = data.subtitle, description = data.description, actionLink = data.actionLink, cardSize = data.cardSize;
    var _ref = size ? variants[size] : variants[cardSize], headingSize = _ref.headingSize, descriptionSize = _ref.descriptionSize, ratio = _ref.ratio;
    var impressionAnalytics = actionLink.impressionAnalytics, clickAnalytics = actionLink.clickAnalytics;
    var clickTracker = useClickTracker4();
    var onClickCapture = React38.useCallback(function() {
        if (clickAnalytics) {
            clickTracker(clickAnalytics.referrerId, clickAnalytics.linkName, void 0, getRecommendationClickedMessage(eventingDetails));
        }
    }, [
        clickAnalytics,
        eventingDetails,
        clickTracker
    ]);
    return /* @__PURE__ */ React38.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: impressionAnalytics.referrerId,
        linkName: impressionAnalytics.linkName,
        additionalUisPrimeMicroMessages: getRecommendationSeenMessage(eventingDetails),
        className: className
    }, /* @__PURE__ */ React38.createElement(EGDSLayoutFlex12, {
        direction: "column"
    }, /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React38.createElement(EGDSFigure3, {
        ratio: ratio,
        roundcorner: true
    }, /* @__PURE__ */ React38.createElement(EGDSImage3, {
        placeholderImage: true,
        alt: incentivesImage.image.description,
        src: incentivesImage.image.url
    }), /* @__PURE__ */ React38.createElement(EGDSImageLink2, null, /* @__PURE__ */ React38.createElement("a", {
        href: actionLink.resource.value,
        onClickCapture: onClickCapture
    }, actionLink.accessibility && /* @__PURE__ */ React38.createElement("span", {
        className: "is-visually-hidden"
    }, actionLink.accessibility))))), /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(EGDSSpacing16, _object_spread({}, itemTitleSpacing), /* @__PURE__ */ React38.createElement(EGDSHeading4, {
        size: headingSize
    }, title)), subtitle && /* @__PURE__ */ React38.createElement(EGDSText12, {
        spacing: "two"
    }, subtitle))), /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem11, null, description && /* @__PURE__ */ React38.createElement(EGDSSpacing16, _object_spread({}, itemDescriptionSpacing), /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(EGDSParagraph3, {
        size: descriptionSize
    }, description)))), /* @__PURE__ */ React38.createElement(EGDSSpacing16, _object_spread({}, itemActionCardSpacing), /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(IncentivesActionLinkButton, {
        data: actionLink,
        handleClickCapture: onClickCapture
    })))));
};
IncentivesContentItem.fragment = __fragment17;
IncentivesContentItem.displayName = "IncentivesContentItem";
// src/components/collection/__private/__fragments/incentives-collection-success.tsx
var __fragment18 = gql39(_templateObject38(), CollectionClickstreamAnalyticsFragment, IncentivesCollectionHeader.fragment, CollectionHeroImage.fragment, IncentivesContentItem.fragment, IncentivesMediaTilesBody.fragment, IncentivesHeroTilesBody.fragment);
var listBlockendSpacing2 = {
    margin: {
        blockend: "twelve"
    },
    padding: {
        inlineend: "six"
    }
};
var defaultImpressionReferrerId = "clp.collection";
var defaultImpressionLinkName = "Incentives CLP impression event";
var gridItemMinWidth = {
    MEDIUM: "half_width",
    LARGE: "full_width"
};
var IncentivesCollectionSuccess = function(param) {
    var data = param.data, fetchMore = param.fetchMore, variables = param.variables;
    var collectionHeader = data.collectionHeader, heroImage = data.heroImage, egRecommendationResponseId = data.egRecommendationResponseId, impressionAnalytics = data.impressionAnalytics, collectionItems = data.collectionItems, collectionBody = data.collectionBody;
    var _React39_useState = _sliced_to_array(React39.useState(false), 2), paginationLoading = _React39_useState[0], setPaginationLoading = _React39_useState[1];
    var paginationContext;
    if ((collectionBody === null || collectionBody === void 0 ? void 0 : collectionBody.__typename) === "IncentivesMediaTilesBody") {
        var _collectionBody_loadMoreAction_paginationQuery, _collectionBody_loadMoreAction;
        paginationContext = collectionBody === null || collectionBody === void 0 ? void 0 : (_collectionBody_loadMoreAction = collectionBody.loadMoreAction) === null || _collectionBody_loadMoreAction === void 0 ? void 0 : (_collectionBody_loadMoreAction_paginationQuery = _collectionBody_loadMoreAction.paginationQuery) === null || _collectionBody_loadMoreAction_paginationQuery === void 0 ? void 0 : _collectionBody_loadMoreAction_paginationQuery.paginationContext;
    }
    var fetchMoreCallback = getFetchMoreCallback(variables, paginationContext, setPaginationLoading, fetchMore);
    var fetchMorePagination = React39.useCallback(fetchMoreCallback, [
        data
    ]);
    var tilesBody = React39.useMemo(function() {
        switch(collectionBody === null || collectionBody === void 0 ? void 0 : collectionBody.__typename){
            case "IncentivesMediaTilesBody":
                return /* @__PURE__ */ React39.createElement(IncentivesMediaTilesBody, {
                    data: collectionBody,
                    paginationHandler: fetchMorePagination,
                    isLoading: paginationLoading
                });
            case "IncentivesHeroTilesBody":
                return /* @__PURE__ */ React39.createElement(IncentivesHeroTilesBody, {
                    data: collectionBody
                });
            default:
                return null;
        }
    }, [
        collectionBody,
        fetchMorePagination,
        paginationLoading
    ]);
    var getCollectionEventingDetails = React39.useCallback(function(index, item) {
        if (!egRecommendationResponseId) {
            return void 0;
        }
        var _collectionHeader_title;
        return {
            egRecommendationResponseId: egRecommendationResponseId,
            title: (_collectionHeader_title = collectionHeader === null || collectionHeader === void 0 ? void 0 : collectionHeader.title) !== null && _collectionHeader_title !== void 0 ? _collectionHeader_title : null,
            componentType: "list",
            items: [
                {
                    index: index,
                    recommendationId: item.recommendationId,
                    title: item.title,
                    imageUrl: item.incentivesImage.image.url,
                    badges: null,
                    price: null
                }
            ]
        };
    }, [
        egRecommendationResponseId,
        collectionHeader === null || collectionHeader === void 0 ? void 0 : collectionHeader.title
    ]);
    var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
    return /* @__PURE__ */ React39.createElement(React39.Fragment, null, heroImage && /* @__PURE__ */ React39.createElement(EGDSSpacing17, {
        margin: imageSpacing.margin
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(CollectionHeroImage, {
        data: heroImage
    }))), /* @__PURE__ */ React39.createElement(IncentivesViewContent, null, collectionHeader && /* @__PURE__ */ React39.createElement(IncentivesCollectionHeader, {
        data: collectionHeader,
        showTermsAndConditions: true,
        isLinkInline: true
    })), collectionItems && /* @__PURE__ */ React39.createElement(IncentivesViewContent, null, /* @__PURE__ */ React39.createElement(EGDSSpacing17, {
        margin: moduleConatinerSpacing.margin
    }, /* @__PURE__ */ React39.createElement(EGDSLayoutFlex13, {
        wrap: "wrap",
        direction: "row"
    }, collectionItems.map(function(item, index) {
        return /* @__PURE__ */ React39.createElement(Viewport5, {
            key: "collection-content-item-".concat(index)
        }, /* @__PURE__ */ React39.createElement(ViewMedium5, null, /* @__PURE__ */ React39.createElement(EGDSLayoutFlexItem12, {
            minWidth: gridItemMinWidth[item.cardSize]
        }, /* @__PURE__ */ React39.createElement(EGDSSpacing17, {
            margin: listBlockendSpacing2.margin,
            padding: listBlockendSpacing2.padding
        }, /* @__PURE__ */ React39.createElement(IncentivesContentItem, {
            data: item,
            eventingDetails: getCollectionEventingDetails(index, item)
        })))), /* @__PURE__ */ React39.createElement(ViewSmall5, null, /* @__PURE__ */ React39.createElement(EGDSLayoutFlexItem12, {
            minWidth: "full_width"
        }, /* @__PURE__ */ React39.createElement(EGDSSpacing17, {
            margin: listBlockendSpacing2.margin
        }, /* @__PURE__ */ React39.createElement(IncentivesContentItem, {
            data: item,
            size: "MEDIUM" /* MEDIUM */ ,
            eventingDetails: getCollectionEventingDetails(index, item)
        })))));
    })))), tilesBody && /* @__PURE__ */ React39.createElement(IntersectionTracker2, {
        trackOnce: true,
        referrerId: (_impressionAnalytics_referrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : defaultImpressionReferrerId,
        linkName: (_impressionAnalytics_linkName = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : defaultImpressionLinkName
    }, /* @__PURE__ */ React39.createElement(IncentivesViewContent, null, tilesBody)));
};
IncentivesCollectionSuccess.fragment = __fragment18;
IncentivesCollectionSuccess.displayName = "IncentivesCollectionSuccess";
// src/components/collection/placeholder.tsx
import React41 from "react";
import { EGDSCard as EGDSCard5, EGDSCardContentSection as EGDSCardContentSection5 } from "@egds/react-core/cards";
import { EGDSCarousel } from "@egds/react-core/carousel";
import { EGDSFigure as EGDSFigure5, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType6 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex15, EGDSLayoutFlexItem as EGDSLayoutFlexItem14 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSBlockSkeleton as EGDSBlockSkeleton2, EGDSLineSkeleton as EGDSLineSkeleton2 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing19 } from "@egds/react-core/spacing";
// ../internal/src/components/incentives-collection-header/incentives-collection-header-placeholder.tsx
import React40 from "react";
import { EGDSFigure as EGDSFigure4, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType5 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex14, EGDSLayoutFlexItem as EGDSLayoutFlexItem13 } from "@egds/react-core/layout-flex";
import { EGDSBlockSkeleton, EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing18 } from "@egds/react-core/spacing";
import { EGDSView as EGDSView3, EGDSViewRow as EGDSViewRow3 } from "@egds/react-core/view";
import { ViewExtraLarge as ViewExtraLarge2, ViewLarge as ViewLarge2, ViewMedium as ViewMedium6, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
var IncentivesCollectionHeaderPlaceholder = function() {
    return /* @__PURE__ */ React40.createElement(React40.Fragment, null, /* @__PURE__ */ React40.createElement(Viewport6, null, /* @__PURE__ */ React40.createElement(ViewSmall6, null, /* @__PURE__ */ React40.createElement(EGDSSpacing18, {
        margin: imageSpacing.margin
    }, /* @__PURE__ */ React40.createElement(EGDSFigure4, {
        ratio: EGDSFigureAspectRatioType5.R1_1
    }, /* @__PURE__ */ React40.createElement(EGDSBlockSkeleton, {
        animation: true
    })))), /* @__PURE__ */ React40.createElement(ViewMedium6, null, /* @__PURE__ */ React40.createElement(EGDSSpacing18, {
        margin: imageSpacing.margin
    }, /* @__PURE__ */ React40.createElement(EGDSFigure4, {
        ratio: EGDSFigureAspectRatioType5.R16_9
    }, /* @__PURE__ */ React40.createElement(EGDSBlockSkeleton, {
        animation: true
    })))), /* @__PURE__ */ React40.createElement(ViewLarge2, null, /* @__PURE__ */ React40.createElement(EGDSSpacing18, {
        margin: imageSpacing.margin
    }, /* @__PURE__ */ React40.createElement(EGDSFigure4, {
        ratio: EGDSFigureAspectRatioType5.R21_9
    }, /* @__PURE__ */ React40.createElement(EGDSBlockSkeleton, {
        animation: true
    })))), /* @__PURE__ */ React40.createElement(ViewExtraLarge2, null, /* @__PURE__ */ React40.createElement(EGDSView3, null, /* @__PURE__ */ React40.createElement(EGDSViewRow3, null, /* @__PURE__ */ React40.createElement(EGDSSpacing18, {
        margin: imageSpacing.margin
    }, /* @__PURE__ */ React40.createElement(EGDSFigure4, {
        ratio: EGDSFigureAspectRatioType5.R21_9,
        roundcorner: true
    }, /* @__PURE__ */ React40.createElement(EGDSBlockSkeleton, {
        animation: true
    }))))))), /* @__PURE__ */ React40.createElement(IncentivesViewContent, null, /* @__PURE__ */ React40.createElement(EGDSLayoutFlex14, {
        direction: "column"
    }, /* @__PURE__ */ React40.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */ React40.createElement(EGDSLineSkeleton, {
        animation: true,
        type: "secondary"
    })), /* @__PURE__ */ React40.createElement(EGDSSpacing18, {
        margin: titleSpacing.margin
    }, /* @__PURE__ */ React40.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */ React40.createElement(EGDSLineSkeleton, {
        animation: true
    }))), /* @__PURE__ */ React40.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */ React40.createElement(EGDSSpacing18, {
        margin: descriptionSpacing.margin
    }, /* @__PURE__ */ React40.createElement(EGDSLineSkeleton, {
        animation: true
    }))))));
};
IncentivesCollectionHeaderPlaceholder.displayName = "IncentivesCollectionHeaderPlaceholder";
// src/components/collection/placeholder.tsx
import { ViewExtraLarge as ViewExtraLarge3, ViewLarge as ViewLarge3, ViewMedium as ViewMedium7, Viewport as Viewport7, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
var ContentItem = function(param) {
    var ratio = param.ratio;
    return /* @__PURE__ */ React41.createElement(EGDSLayoutFlex15, {
        direction: "column"
    }, /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React41.createElement(EGDSFigure5, {
        ratio: ratio,
        roundcorner: true
    }, /* @__PURE__ */ React41.createElement(EGDSBlockSkeleton2, {
        animation: true
    }))), /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React41.createElement(EGDSSpacing19, _object_spread({}, itemTitleSpacing), /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, {
        animation: true,
        type: "secondary"
    })), /* @__PURE__ */ React41.createElement(EGDSSpacing19, null, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, {
        animation: true
    }))), /* @__PURE__ */ React41.createElement(EGDSSpacing19, _object_spread({}, itemDescriptionSpacing), /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, {
        animation: true
    })));
};
var Placeholder = function() {
    return /* @__PURE__ */ React41.createElement(React41.Fragment, null, /* @__PURE__ */ React41.createElement(IncentivesCollectionHeaderPlaceholder, null), /* @__PURE__ */ React41.createElement(IncentivesViewContent, null, /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
        margin: moduleConatinerSpacing.margin
    }, /* @__PURE__ */ React41.createElement(EGDSLayoutGrid3, {
        columns: itemsGridColumns,
        space: gridSpacing2
    }, _to_consumable_array(Array(5)).map(function(_, index) {
        return /* @__PURE__ */ React41.createElement(Viewport7, {
            key: "collection-content-item-".concat(index)
        }, /* @__PURE__ */ React41.createElement(ViewSmall7, null, /* @__PURE__ */ React41.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */ React41.createElement(ContentItem, {
            ratio: EGDSFigureAspectRatioType6.R3_2
        }))), /* @__PURE__ */ React41.createElement(ViewMedium7, null, /* @__PURE__ */ React41.createElement(EGDSLayoutGridItem3, {
            colSpan: index === 0 ? "all" : 1
        }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(ContentItem, {
            ratio: index === 0 ? EGDSFigureAspectRatioType6.R21_9 : EGDSFigureAspectRatioType6.R3_2
        })))));
    })))));
};
var IncentivesCollectionHeadingPlaceholder = function() {
    return /* @__PURE__ */ React41.createElement(EGDSLayoutFlex15, {
        direction: "column"
    }, /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
        margin: titleSpacing.margin
    }, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, {
        type: "secondary"
    }))), /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React41.createElement(EGDSSpacing19, _object_spread({}, itemDescriptionSpacing), /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, null))), /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React41.createElement(EGDSSpacing19, _object_spread({}, itemDescriptionSpacing), /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, {
        type: "secondary"
    }))));
};
var GridPlaceholder = function() {
    return /* @__PURE__ */ React41.createElement(React41.Fragment, null, /* @__PURE__ */ React41.createElement(IncentivesCollectionHeadingPlaceholder, null), /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
        margin: moduleConatinerSpacing.margin
    }, /* @__PURE__ */ React41.createElement(EGDSLayoutGrid3, {
        columns: collectionGridColumns,
        space: gridSpacing2
    }, _to_consumable_array(Array(6)).map(function(_, index) {
        return /* @__PURE__ */ React41.createElement(Viewport7, {
            key: "collection-content-item-".concat(index)
        }, /* @__PURE__ */ React41.createElement(ViewSmall7, null, /* @__PURE__ */ React41.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */ React41.createElement(ContentItem, {
            ratio: EGDSFigureAspectRatioType6.R3_2
        }))), /* @__PURE__ */ React41.createElement(ViewMedium7, null, /* @__PURE__ */ React41.createElement(EGDSLayoutGridItem3, {
            colSpan: 1
        }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(ContentItem, {
            ratio: EGDSFigureAspectRatioType6.R3_2
        })))));
    }))));
};
var packagesCardPlaceholder = /* @__PURE__ */ React41.createElement(EGDSCard5, {
    border: true
}, /* @__PURE__ */ React41.createElement(EGDSFigure5, {
    ratio: EGDSFigureAspectRatioType6.R16_9
}, /* @__PURE__ */ React41.createElement(EGDSBlockSkeleton2, null)), /* @__PURE__ */ React41.createElement(EGDSCardContentSection5, null, /* @__PURE__ */ React41.createElement(EGDSLayoutFlex15, {
    direction: "column"
}, /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
    margin: {
        blockstart: "three"
    }
}, /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, null))), /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
    margin: {
        blockstart: "three",
        blockend: "twelve"
    }
}, /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, {
    type: "secondary"
}))), /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
    margin: {
        blockstart: "sixteen",
        blockend: "eight"
    }
}, /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, {
    alignSelf: "end"
}, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, {
    type: "secondary"
}))))));
var PackagesCarouselPlaceholder = function() {
    return /* @__PURE__ */ React41.createElement(EGDSCard5, {
        padded: true
    }, /* @__PURE__ */ React41.createElement(EGDSCardContentSection5, null, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, null)), /* @__PURE__ */ React41.createElement(EGDSCardContentSection5, null, /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, null))), /* @__PURE__ */ React41.createElement(EGDSCarousel, {
        pagingInset: true,
        peek: true,
        itemsVisible: {
            xl: 4,
            lg: 3,
            md: 2,
            sm: 1
        },
        innerSpacing: {
            sm: 12,
            md: 12,
            lg: 12
        },
        wrapItems: false,
        buttonText: {
            nextButton: "",
            prevButton: ""
        }
    }, packagesCardPlaceholder, packagesCardPlaceholder, packagesCardPlaceholder, packagesCardPlaceholder, packagesCardPlaceholder), /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
        margin: {
            blockstart: "six",
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React41.createElement(EGDSLayoutFlex15, {
        direction: "row",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, {
        type: "secondary"
    })), /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, null)))));
};
var placeholderCard = /* @__PURE__ */ React41.createElement(EGDSCard5, {
    border: true
}, /* @__PURE__ */ React41.createElement(EGDSSpacing19, null, /* @__PURE__ */ React41.createElement(EGDSFigure5, {
    ratio: EGDSFigureAspectRatioType6.R16_9
}, /* @__PURE__ */ React41.createElement(EGDSBlockSkeleton2, null))), /* @__PURE__ */ React41.createElement(EGDSCardContentSection5, null, /* @__PURE__ */ React41.createElement(EGDSLayoutFlex15, {
    direction: "column"
}, /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
    margin: {
        blockstart: "three"
    }
}, /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, null))), /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
    margin: {
        blockstart: "three",
        blockend: "twelve"
    }
}, /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, {
    type: "secondary"
}))), /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
    margin: {
        blockstart: "sixteen",
        blockend: "eight"
    }
}, /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem14, {
    alignSelf: "end"
}, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, {
    type: "secondary"
}))))));
var gridTile = /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
    margin: {
        blockstart: "three"
    }
}, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(EGDSCardContentSection5, null, /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
    margin: {
        blockend: "three"
    }
}, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, null))), /* @__PURE__ */ React41.createElement(EGDSLayoutGrid3, {
    columns: {
        small: 1,
        medium: 2,
        large: 3,
        extra_large: 4
    },
    space: "three"
}, /* @__PURE__ */ React41.createElement(Viewport7, null, /* @__PURE__ */ React41.createElement(ViewExtraLarge3, null, /* @__PURE__ */ React41.createElement(React41.Fragment, null, placeholderCard, placeholderCard, placeholderCard, placeholderCard)), /* @__PURE__ */ React41.createElement(ViewLarge3, null, /* @__PURE__ */ React41.createElement(React41.Fragment, null, placeholderCard, placeholderCard, placeholderCard)), /* @__PURE__ */ React41.createElement(ViewMedium7, null, /* @__PURE__ */ React41.createElement(React41.Fragment, null, placeholderCard, placeholderCard)), /* @__PURE__ */ React41.createElement(ViewSmall7, null, placeholderCard))), /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
    margin: {
        blockstart: "six",
        inlinestart: "three"
    }
}, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, {
    type: "secondary"
}))));
var PackagesGridLoader = function() {
    return /* @__PURE__ */ React41.createElement(EGDSCard5, {
        padded: true
    }, /* @__PURE__ */ React41.createElement(EGDSCardContentSection5, null, /* @__PURE__ */ React41.createElement(EGDSLineSkeleton2, null)), gridTile, gridTile);
};
// src/components/collection/incentives-collection.tsx
var __Query = gql40(_templateObject39(), IncentivesCollectionError.fragment, IncentivesCollectionSuccess.fragment);
var IncentivesCollectionView = function(props) {
    var _data_incentivesCollectionView;
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_view = props.view, view = _props_view === void 0 ? "default" /* Default */  : _props_view;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs || {}), {
        context: context
    });
    var viewConfig = IncentivesCollectionViewMap[view];
    var _useQuery = useQuery(__Query, _object_spread_props(_object_spread({
        variables: variables
    }, viewConfig), {
        ssr: !skipSsr
    })), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading, fetchMore = _useQuery.fetchMore;
    if (loading) {
        return /* @__PURE__ */ React42.createElement(Placeholder, null);
    }
    if (error) {
        return null;
    }
    switch(data === null || data === void 0 ? void 0 : (_data_incentivesCollectionView = data.incentivesCollectionView) === null || _data_incentivesCollectionView === void 0 ? void 0 : _data_incentivesCollectionView.__typename){
        case "IncentivesCollectionError":
            return /* @__PURE__ */ React42.createElement(IncentivesCollectionError, {
                data: data === null || data === void 0 ? void 0 : data.incentivesCollectionView
            });
        case "IncentivesCollectionSuccess":
            var _data_incentivesCollectionView1;
            if (data === null || data === void 0 ? void 0 : (_data_incentivesCollectionView1 = data.incentivesCollectionView) === null || _data_incentivesCollectionView1 === void 0 ? void 0 : _data_incentivesCollectionView1.presentedAnalytics) {
                var _data_incentivesCollectionView2;
                return /* @__PURE__ */ React42.createElement(EgClickstreamImpressionTracker3, {
                    eventData: buildClickstreamAnalyticsEvent(data === null || data === void 0 ? void 0 : (_data_incentivesCollectionView2 = data.incentivesCollectionView) === null || _data_incentivesCollectionView2 === void 0 ? void 0 : _data_incentivesCollectionView2.presentedAnalytics)
                }, /* @__PURE__ */ React42.createElement(IncentivesCollectionSuccess, {
                    data: data === null || data === void 0 ? void 0 : data.incentivesCollectionView,
                    fetchMore: fetchMore,
                    variables: variables
                }));
            }
            return /* @__PURE__ */ React42.createElement(IncentivesCollectionSuccess, {
                data: data === null || data === void 0 ? void 0 : data.incentivesCollectionView,
                fetchMore: fetchMore,
                variables: variables
            });
        default:
            return null;
    }
};
IncentivesCollectionView.displayName = "sharedui-IncentivesCollectionView";
// src/components/collection/incentives-collection-grid.tsx
import React47 from "react";
import { gql as gql45, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker5, IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/collection-grouped-media-tiles-body/collection-grouped-media-tiles-body.tsx
import React46 from "react";
import { gql as gql44 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing22 } from "@egds/react-core/spacing";
// ../internal/src/components/incentives-media-tile/packages-incentives-media-tile.tsx
import React45 from "react";
import { gql as gql43 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize3 } from "@egds/react-core/button";
import { EGDSCard as EGDSCard6, EGDSCardContentSection as EGDSCardContentSection6, EGDSCardLink as EGDSCardLink4 } from "@egds/react-core/cards";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType7 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex17, EGDSLayoutFlexItem as EGDSLayoutFlexItem16 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing21 } from "@egds/react-core/spacing";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker4, useClickTracker as useClickTracker5, useEgClickstream as useEgClickstream5 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-spannable-list/egds-spannable-list.tsx
import React44 from "react";
import { gql as gql42 } from "@apollo/client";
import { EGDSList } from "@egds/react-core/list";
// ../internal/src/components/egds-spannable-list/egds-spannable-list-item.tsx
import React43 from "react";
import { gql as gql41 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex16, EGDSLayoutFlexItem as EGDSLayoutFlexItem15 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing20 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText13 } from "@egds/react-core/text";
var fragment21 = gql41(_templateObject40(), UIGraphic.fragment, SpannableText.fragment);
var SpannableListItem = function(param) {
    var data = param.data, textSize = param.textSize, subtextSize = param.subtextSize;
    var graphic = data.graphic, subText = data.subText, text = data.text;
    return /* @__PURE__ */ React43.createElement(EGDSLayoutFlex16, null, /* @__PURE__ */ React43.createElement(EGDSLayoutFlexItem15, {
        alignSelf: "center"
    }, graphic && /* @__PURE__ */ React43.createElement(EGDSSpacing20, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(UIGraphic, {
        data: graphic
    })))), /* @__PURE__ */ React43.createElement(EGDSLayoutFlexItem15, {
        alignSelf: "center"
    }, /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(SpannableText, {
        data: text,
        size: textSize
    }), /* @__PURE__ */ React43.createElement(EGDSText13, {
        size: subtextSize
    }, subText))));
};
SpannableListItem.displayName = "SpannableListItem";
SpannableListItem.fragment = fragment21;
// ../internal/src/components/egds-spannable-list/egds-spannable-list.tsx
var fragment22 = gql42(_templateObject41(), SpannableListItem.fragment);
var bulletListTypeMapping = function(listType) {
    switch(listType){
        case "BULLET":
            return "default";
        case "ICON":
            return "icon-standard";
        case "NO_BULLET":
            return "no-bullet";
        case "NUMBER":
            return "tiered-numbered";
        default:
            return void 0;
    }
};
var SpannableList = function(param) {
    var data = param.data, textSize = param.textSize, subtextSize = param.subtextSize;
    if (data.items.length === 0) {
        return null;
    }
    var listType = data.listType, items = data.items;
    return /* @__PURE__ */ React44.createElement(EGDSList, {
        bullet: bulletListTypeMapping(listType),
        spacing: false
    }, items.map(function(item, key) {
        return /* @__PURE__ */ React44.createElement(SpannableListItem, {
            data: item,
            key: key,
            textSize: textSize,
            subtextSize: subtextSize
        });
    }));
};
SpannableList.displayName = "SpannableList";
SpannableList.fragment = fragment22;
// ../internal/src/components/incentives-media-tile/packages-incentives-media-tile.tsx
var fragment23 = gql43(_templateObject42(), IncentivesMedia.fragment, SpannableList.fragment, IncentivesActionLink.fragment, IncentivesTileContent.fragment, IncentivesMediaTilePrice.fragment);
var PackagesIncentivesMediaTile = function(param) {
    var data = param.data, _param_cardContentSize = param.cardContentSize, cardContentSize = _param_cardContentSize === void 0 ? "FOUNDATION" /* FOUNDATION */  : _param_cardContentSize, multiArmBanditTrack = param.multiArmBanditTrack, multipleHeader = param.multipleHeader;
    var _tileContentProps_titleProps;
    var media = data.media, details = data.details, content = data.content, price = data.price, cardLink = data.cardLink, action = data.action;
    var clickTracker = useClickTracker5();
    var track = useEgClickstream5();
    var onImageClick = React45.useCallback(function() {
        multiArmBanditTrack === null || multiArmBanditTrack === void 0 ? void 0 : multiArmBanditTrack();
        clickTracker(cardLink.clickAnalytics.referrerId, cardLink.clickAnalytics.linkName);
        if (cardLink.selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(cardLink.selectedAnalytics));
        }
        window.open(cardLink.resource.value, "_self");
    }, [
        cardLink,
        track,
        clickTracker,
        multiArmBanditTrack
    ]);
    var padding = cardContentSize === "PADDED_CARD" /* PADDED_CARD */  ? PaddedCardPadding : FoundationPadding;
    var isPaddedCard = cardContentSize === "PADDED_CARD" /* PADDED_CARD */ ;
    var renderActionLinkArea = function() {
        if (action === null || action === void 0 ? void 0 : action.button) {
            return /* @__PURE__ */ React45.createElement(EGDSSpacing21, {
                margin: padding.actionButtonSpacing.margin
            }, /* @__PURE__ */ React45.createElement(IncentivesActionLink, {
                data: action,
                buttonSize: EGDSButtonSize3.SMALL,
                multiArmBanditTrack: multiArmBanditTrack
            }));
        }
        return null;
    };
    var tileContentProps = multipleHeader ? padding.contentProps : clpContentProps;
    var mediaTile = /* @__PURE__ */ React45.createElement(EGDSCard6, {
        className: "uitk-layout-flex-block-size-full-size",
        border: true
    }, /* @__PURE__ */ React45.createElement(EGDSCardLink4, null, /* @__PURE__ */ React45.createElement(IncentivesActionLink, {
        data: cardLink,
        multiArmBanditTrack: multiArmBanditTrack,
        visuallyHidden: true
    })), /* @__PURE__ */ React45.createElement(EGDSLayoutFlex17, {
        direction: "column",
        justifyContent: "space-between",
        blockSize: "full_size"
    }, /* @__PURE__ */ React45.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */ React45.createElement(IncentivesMedia, {
        carouselId: "incentives-media-tile-carousel-".concat(cardLink.clickAnalytics.referrerId),
        data: media,
        allyHeadingLevel: (_tileContentProps_titleProps = tileContentProps.titleProps) === null || _tileContentProps_titleProps === void 0 ? void 0 : _tileContentProps_titleProps.tag,
        ratio: EGDSFigureAspectRatioType7.R16_9,
        onImageClick: onImageClick
    })), /* @__PURE__ */ React45.createElement(EGDSLayoutFlexItem16, {
        grow: 1
    }, /* @__PURE__ */ React45.createElement(EGDSCardContentSection6, {
        padded: true
    }, /* @__PURE__ */ React45.createElement(EGDSLayoutFlex17, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React45.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */ React45.createElement("div", null, /* @__PURE__ */ React45.createElement(IncentivesTileContent, {
        data: content,
        titleProps: tileContentProps.titleProps,
        subTitleProps: tileContentProps.subTitleProps,
        descriptionProps: tileContentProps.descriptionProps,
        isPaddedCard: isPaddedCard,
        isDescriptionHidden: true
    }), details ? /* @__PURE__ */ React45.createElement(EGDSSpacing21, {
        margin: padding.detailsSpacing.margin
    }, /* @__PURE__ */ React45.createElement("div", null, /* @__PURE__ */ React45.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */ React45.createElement(SpannableList, {
        data: details,
        textSize: 200
    })))) : null)), /* @__PURE__ */ React45.createElement(EGDSLayoutFlexItem16, {
        alignSelf: "end"
    }, /* @__PURE__ */ React45.createElement(IncentivesMediaTilePrice, {
        data: price,
        isPackages: true
    })), /* @__PURE__ */ React45.createElement(EGDSLayoutFlexItem16, null, isPaddedCard && renderActionLinkArea()))))));
    if (cardLink.presentedAnalytics) {
        return /* @__PURE__ */ React45.createElement(EgClickstreamImpressionTracker4, {
            eventData: buildClickstreamAnalyticsEvent(cardLink.presentedAnalytics)
        }, mediaTile);
    }
    return mediaTile;
};
PackagesIncentivesMediaTile.fragment = fragment23;
PackagesIncentivesMediaTile.displayName = "PackagesIncentivesMediaTile";
// ../internal/src/components/collection-grouped-media-tiles-body/collection-grouped-media-tiles-body.tsx
var __fragment19 = gql44(_templateObject43(), IncentivesTileContent.fragment, IncentivesResultsSummary.fragment, IncentivesActionLink.fragment, PackagesIncentivesMediaTile.fragment);
var tileSpacing = {
    margin: {
        blockstart: "eight"
    }
};
var gridSpacing3 = {
    margin: {
        blockstart: "three"
    }
};
var ctaSpacing = {
    margin: {
        blockstart: "four"
    }
};
var CollectionGroupedMediaTilesBody = function(param) {
    var data = param.data, _param_cardContentSize = param.cardContentSize, cardContentSize = _param_cardContentSize === void 0 ? "FOUNDATION" /* FOUNDATION */  : _param_cardContentSize, titleSize = param.titleSize;
    var tiles = data.tiles, summary = data.summary;
    var getGridOffers = function(offer, offerIndex) {
        return /* @__PURE__ */ React46.createElement(EGDSLayoutGridItem4, {
            key: "collection-packages-grid-offer-".concat(offerIndex)
        }, /* @__PURE__ */ React46.createElement(PackagesIncentivesMediaTile, {
            data: offer,
            multipleHeader: true,
            cardContentSize: cardContentSize
        }));
    };
    var gridTiles = function(tile, tileIndex) {
        return /* @__PURE__ */ React46.createElement(EGDSSpacing22, {
            margin: tileSpacing.margin,
            key: "collection-packages-grid-".concat(tileIndex)
        }, /* @__PURE__ */ React46.createElement("div", null, /* @__PURE__ */ React46.createElement(IncentivesTileContent, {
            data: tile.content,
            titleProps: {
                size: titleSize
            }
        }), /* @__PURE__ */ React46.createElement(EGDSSpacing22, {
            margin: gridSpacing3.margin
        }, /* @__PURE__ */ React46.createElement("div", null, /* @__PURE__ */ React46.createElement(EGDSLayoutGrid4, {
            columns: {
                extra_large: 4,
                large: 3,
                medium: 2,
                small: 1
            },
            space: {
                column: "three",
                row: "xlarge"
            }
        }, tile.offers.map(function(offer, offerIndex) {
            return getGridOffers(offer, offerIndex);
        })), tile.ctaButton && /* @__PURE__ */ React46.createElement(EGDSSpacing22, {
            margin: ctaSpacing.margin
        }, /* @__PURE__ */ React46.createElement("div", null, /* @__PURE__ */ React46.createElement(IncentivesActionLink, {
            data: tile.ctaButton
        })))))));
    };
    return /* @__PURE__ */ React46.createElement(React46.Fragment, null, summary && /* @__PURE__ */ React46.createElement(IncentivesResultsSummary, {
        data: summary
    }), tiles.map(function(tile, tileIndex) {
        return gridTiles(tile, tileIndex);
    }));
};
CollectionGroupedMediaTilesBody.fragment = __fragment19;
CollectionGroupedMediaTilesBody.displayName = "CollectionGroupedMediaTilesBody";
// src/components/collection/incentives-collection-grid.tsx
var __Query2 = gql45(_templateObject44(), CollectionClickstreamAnalyticsFragment, IncentivesCollectionHeader.fragment, IncentivesMediaTilesBody.fragment, IncentivesHeroTilesBody.fragment, CollectionGroupedMediaTilesBody.fragment);
var defaultImpressionReferrerId2 = "clp.collection";
var defaultImpressionLinkName2 = "Incentives CLP impression event";
var IncentivesCollectionGrid = function(props) {
    var _data_incentivesCollection, _data_incentivesCollection1;
    var inputs = props.inputs, skipSsr = props.skipSsr, hideHeaderTitle = props.hideHeaderTitle, hideHeaderSubtitle = props.hideHeaderSubtitle, hideHeaderDescription = props.hideHeaderDescription, hideSummary = props.hideSummary, hideTermsAndConditions = props.hideTermsAndConditions, hideCarouselCTA = props.hideCarouselCTA, cardContentSize = props.cardContentSize;
    var context = useBexApi2().context;
    var _React47_useState = _sliced_to_array(React47.useState(false), 2), paginationLoading = _React47_useState[0], setPaginationLoading = _React47_useState[1];
    var variables = _object_spread_props(_object_spread({}, inputs || {}), {
        context: context,
        hideHeaderTitle: hideHeaderTitle !== null && hideHeaderTitle !== void 0 ? hideHeaderTitle : false,
        hideHeaderSubtitle: hideHeaderSubtitle !== null && hideHeaderSubtitle !== void 0 ? hideHeaderSubtitle : false,
        hideHeaderDescription: hideHeaderDescription !== null && hideHeaderDescription !== void 0 ? hideHeaderDescription : false,
        hideSummary: hideSummary !== null && hideSummary !== void 0 ? hideSummary : false,
        hideTermsAndConditions: hideTermsAndConditions !== null && hideTermsAndConditions !== void 0 ? hideTermsAndConditions : false,
        hideCarouselCTA: hideCarouselCTA !== null && hideCarouselCTA !== void 0 ? hideCarouselCTA : true
    });
    var _useQuery2 = useQuery2(__Query2, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading, fetchMore = _useQuery2.fetchMore;
    var paginationContext;
    var collectionBody = (data === null || data === void 0 ? void 0 : (_data_incentivesCollection = data.incentivesCollection) === null || _data_incentivesCollection === void 0 ? void 0 : _data_incentivesCollection.collectionBody) || null;
    if ((collectionBody === null || collectionBody === void 0 ? void 0 : collectionBody.__typename) === "IncentivesMediaTilesBody") {
        var _collectionBody_loadMoreAction_paginationQuery, _collectionBody_loadMoreAction;
        paginationContext = collectionBody === null || collectionBody === void 0 ? void 0 : (_collectionBody_loadMoreAction = collectionBody.loadMoreAction) === null || _collectionBody_loadMoreAction === void 0 ? void 0 : (_collectionBody_loadMoreAction_paginationQuery = _collectionBody_loadMoreAction.paginationQuery) === null || _collectionBody_loadMoreAction_paginationQuery === void 0 ? void 0 : _collectionBody_loadMoreAction_paginationQuery.paginationContext;
    }
    var fetchMoreCallback = getFetchMoreCallback(variables, paginationContext, setPaginationLoading, fetchMore);
    var fetchMorePagination = React47.useCallback(fetchMoreCallback, [
        data
    ]);
    var tilesBody = React47.useMemo(function() {
        if (!(data === null || data === void 0 ? void 0 : data.incentivesCollection)) {
            return null;
        }
        switch(collectionBody === null || collectionBody === void 0 ? void 0 : collectionBody.__typename){
            case "IncentivesMediaTilesBody":
                return /* @__PURE__ */ React47.createElement(IncentivesMediaTilesBody, {
                    data: collectionBody,
                    paginationHandler: fetchMorePagination,
                    isLoading: paginationLoading,
                    multipleHeader: true
                });
            case "IncentivesHeroTilesBody":
                return /* @__PURE__ */ React47.createElement(IncentivesHeroTilesBody, {
                    data: collectionBody,
                    multipleHeader: true
                });
            case "CollectionGroupedMediaTilesBody":
                return /* @__PURE__ */ React47.createElement(CollectionGroupedMediaTilesBody, {
                    data: collectionBody,
                    cardContentSize: cardContentSize,
                    titleSize: 5
                });
            default:
                return null;
        }
    }, [
        collectionBody,
        data === null || data === void 0 ? void 0 : data.incentivesCollection,
        fetchMorePagination,
        paginationLoading,
        cardContentSize
    ]);
    if (loading) {
        switch(variables.expectedCollectionType){
            case "PACKAGE":
                return /* @__PURE__ */ React47.createElement(PackagesGridLoader, null);
            default:
                return /* @__PURE__ */ React47.createElement(GridPlaceholder, null);
        }
    }
    if (error || !data) {
        return null;
    }
    var _data_incentivesCollection2 = data.incentivesCollection, collectionHeader = _data_incentivesCollection2.collectionHeader, impressionAnalytics = _data_incentivesCollection2.impressionAnalytics;
    var isCollectionGroupedMediaTilesBody = (collectionBody === null || collectionBody === void 0 ? void 0 : collectionBody.__typename) === "CollectionGroupedMediaTilesBody";
    var headerTextSize = isCollectionGroupedMediaTilesBody ? 300 : void 0;
    var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
    var gridContent = /* @__PURE__ */ React47.createElement(React47.Fragment, null, collectionHeader && /* @__PURE__ */ React47.createElement(IncentivesCollectionHeader, {
        data: collectionHeader,
        multipleHeader: true,
        showTermsAndConditions: true,
        isLinkInline: !isCollectionGroupedMediaTilesBody,
        textSize: headerTextSize
    }), tilesBody && /* @__PURE__ */ React47.createElement(IntersectionTracker3, {
        trackOnce: true,
        referrerId: (_impressionAnalytics_referrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : defaultImpressionReferrerId2,
        linkName: (_impressionAnalytics_linkName = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : defaultImpressionLinkName2
    }, tilesBody));
    return (data === null || data === void 0 ? void 0 : (_data_incentivesCollection1 = data.incentivesCollection) === null || _data_incentivesCollection1 === void 0 ? void 0 : _data_incentivesCollection1.presentedAnalytics) ? /* @__PURE__ */ React47.createElement(EgClickstreamImpressionTracker5, {
        eventData: buildClickstreamAnalyticsEvent(data.incentivesCollection.presentedAnalytics)
    }, gridContent) : gridContent;
};
IncentivesCollectionGrid.displayName = "sharedui-IncentivesCollectionGrid";
// src/components/collection/collection-lodging-carousel/collection-lodging-carousel.tsx
import React52, { useEffect } from "react";
import { gql as gql47, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
// ../internal/src/utility/analytics/analytics.ts
import { ITrackType, useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
var referrerMapper = function(referrerId, linkName, eventType) {
    return {
        schemaName: "referrer",
        messageContent: {
            referrerId: referrerId,
            linkName: linkName,
            eventType: eventType
        }
    };
};
var uisMicroMessagesAggregator = function(message, additionalMessages) {
    if (Array.isArray(additionalMessages) && additionalMessages.length) {
        return [
            message
        ].concat(_to_consumable_array(additionalMessages));
    }
    return message;
};
var useTracker = function() {
    var track = useClickstreamAnalytics().track;
    return function(referrerId, linkName, eventType, delay) {
        return track(ITrackType.EVENT, {
            data: uisMicroMessagesAggregator(referrerMapper(referrerId, linkName, eventType)),
            config: {
                delay: delay
            }
        });
    };
};
function sendTracking(analytics, track) {
    var eventType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "impression";
    track(analytics.referrerId, (analytics === null || analytics === void 0 ? void 0 : analytics.linkName) || "", eventType, void 0);
}
// src/components/placeholder.tsx
import React48 from "react";
import { EGDSCarousel as EGDSCarousel2 } from "@egds/react-core/carousel";
import { EGDSFigure as EGDSFigure6, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType8 } from "@egds/react-core/images";
import { EGDSBlockSkeleton as EGDSBlockSkeleton3, EGDSLineSkeleton as EGDSLineSkeleton3 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing23 } from "@egds/react-core/spacing";
import { useLocalization } from "@shared-ui/localization-context";
var Placeholder2 = function() {
    var formatText = useLocalization().formatText;
    var carouselProps = {
        carouselName: "IncentivesCollectionCarousel",
        itemsVisible: {
            sm: 1,
            md: 2,
            lg: 3,
            xl: 4
        },
        pageBy: 1,
        peek: true,
        wrapItems: false,
        buttonText: {
            nextButton: formatText("carousel.item.next"),
            prevButton: formatText("carousel.item.prev")
        }
    };
    return /* @__PURE__ */ React48.createElement(React48.Fragment, null, /* @__PURE__ */ React48.createElement(EGDSSpacing23, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React48.createElement(EGDSLineSkeleton3, {
        animation: true
    })), /* @__PURE__ */ React48.createElement(EGDSCarousel2, _object_spread({}, carouselProps), _to_consumable_array(Array(6)).map(function(_, index) {
        return /* @__PURE__ */ React48.createElement("div", {
            key: "incentives-collection-placeholder-card-".concat(index)
        }, /* @__PURE__ */ React48.createElement(EGDSFigure6, {
            ratio: EGDSFigureAspectRatioType8.R4_3
        }, /* @__PURE__ */ React48.createElement(EGDSBlockSkeleton3, {
            animation: true
        })));
    })));
};
// src/components/collection/collection-lodging-carousel/views/default-lodging-carousel.tsx
import React49 from "react";
import { EGDSCarousel as EGDSCarousel3 } from "@egds/react-core/carousel";
import { EGDSSpacing as EGDSSpacing24 } from "@egds/react-core/spacing";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker6, useEgClickstream as useEgClickstream6 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
import { useMultiArmBanditContext } from "@shared-ui/retail-travel-content-experience-orchestration";
import { ViewMedium as ViewMedium8, Viewport as Viewport8, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
var DefaultLodgingCarousel = function(props) {
    var collectionHeader = props.collectionHeader, mediaBody = props.mediaBody, presentedAnalytics = props.presentedAnalytics, cardContentSize = props.cardContentSize;
    var formatText = useLocalization2().formatText;
    var track = useEgClickstream6();
    var multiArmBanditTrack = useMultiArmBanditContext().multiArmBanditTrack;
    var bodySpacings = {
        margin: {
            blockstart: "one"
        },
        padding: {
            blockstart: "two"
        }
    };
    var carouselSpacings = {
        margin: {
            blockstart: "three"
        }
    };
    var carouselIndex = -1;
    var handleCarouselAnalyticsByArrowClick = function(index) {
        if (carouselIndex === -1 && index === 0) {
            return;
        }
        var selectedAnalytics = index >= carouselIndex ? mediaBody.previousSelectedAnalytics : mediaBody.nextSelectedAnalytics;
        track(buildClickstreamAnalyticsEvent(selectedAnalytics));
        carouselIndex = index;
    };
    var carouselProps = {
        carouselName: "DefaultLodgingCarousel",
        onIndexChange: handleCarouselAnalyticsByArrowClick,
        itemsVisible: {
            sm: 1,
            md: 2,
            lg: 3,
            xl: 4
        },
        pageBy: 1,
        peek: true,
        buttonText: {
            nextButton: formatText("carousel.item.next") || "Next",
            prevButton: formatText("carousel.item.prev") || "Previous"
        }
    };
    return /* @__PURE__ */ React49.createElement(React49.Fragment, null, presentedAnalytics && /* @__PURE__ */ React49.createElement(EgClickstreamImpressionTracker6, {
        trackOnce: true,
        eventData: buildClickstreamAnalyticsEvent(presentedAnalytics)
    }, collectionHeader && /* @__PURE__ */ React49.createElement(IncentivesCollectionHeader, {
        data: collectionHeader,
        multipleHeader: true,
        showCTAButton: true,
        showTermsAndConditions: true,
        isLinkInline: true
    }), /* @__PURE__ */ React49.createElement(EGDSSpacing24, {
        margin: bodySpacings.margin
    }, /* @__PURE__ */ React49.createElement("div", null, mediaBody.summary && /* @__PURE__ */ React49.createElement(IncentivesResultsSummary, {
        data: mediaBody.summary
    }), mediaBody.carouselCTAButton && /* @__PURE__ */ React49.createElement(Viewport8, null, /* @__PURE__ */ React49.createElement(ViewSmall8, null, /* @__PURE__ */ React49.createElement(EGDSSpacing24, {
        margin: {
            blockstart: "four",
            blockend: "one"
        }
    }, /* @__PURE__ */ React49.createElement(IncentivesActionLink, {
        data: mediaBody.carouselCTAButton,
        multiArmBanditTrack: multiArmBanditTrack
    }))), /* @__PURE__ */ React49.createElement(ViewMedium8, null)), /* @__PURE__ */ React49.createElement(EGDSSpacing24, {
        margin: carouselSpacings.margin
    }, /* @__PURE__ */ React49.createElement(EGDSCarousel3, _object_spread_props(_object_spread({}, carouselProps), {
        itemsMaxHeight: true
    }), mediaBody.tiles.map(function(item, index) {
        return /* @__PURE__ */ React49.createElement(IncentivesMediaTile, {
            key: "collection-carousel-content-item-".concat(index),
            data: item,
            multiArmBanditTrack: multiArmBanditTrack,
            cardContentSize: cardContentSize,
            multipleHeader: true
        });
    })))))));
};
DefaultLodgingCarousel.displayName = "sharedui-DefaultLodgingCarousel";
// src/components/collection/collection-lodging-carousel/views/hero-lodging-carousel.tsx
import React51 from "react";
import { EGDSCarousel as EGDSCarousel4 } from "@egds/react-core/carousel";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex19 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing26 } from "@egds/react-core/spacing";
import { EGDSThemeProvider as EGDSThemeProvider2 } from "@egds/react-core/utils";
import { EGDSTeamCardBorderRadiusIncrease, EGDSTeamFigureRefactor, EGDSTeamHeadingBreakpointSizing, EGDSTeamImageRefactor, EGDSTeamLayoutGridContainerBasedSizing, EGDSTeamLayoutGridContainerBasedSizingItem, EGDSTeamScrimRefactor, EGDSTeamSubheadingBreakpointSizing } from "@egds/react-one-design-language";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker8, useClickTracker as useClickTracker7, useEgClickstream as useEgClickstream8 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization3 } from "@shared-ui/localization-context";
// ../internal/src/components/incentives-media-tile/incentives-hero-media-tile.tsx
import React50 from "react";
import { gql as gql46 } from "@apollo/client";
import { EGDSCardLink as EGDSCardLink5 } from "@egds/react-core/cards";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType9 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex18, EGDSLayoutFlexItem as EGDSLayoutFlexItem17 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing25 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading5, EGDSText as EGDSText14 } from "@egds/react-core/text";
import { EGDSThemeProvider } from "@egds/react-core/utils";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker7, useClickTracker as useClickTracker6, useEgClickstream as useEgClickstream7 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium9, Viewport as Viewport9, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
var __fragment20 = gql46(_templateObject45(), IncentivesMedia.fragment, SpannableText.fragment, IncentivesActionLink.fragment, IncentivesTileContent.fragment, IncentivesMediaTilePrice.fragment);
var IncentivesHeroMediaTile = function(param) {
    var data = param.data, _param_cardContentSize = param.cardContentSize, cardContentSize = _param_cardContentSize === void 0 ? "FOUNDATION" /* FOUNDATION */  : _param_cardContentSize, multiArmBanditTrack = param.multiArmBanditTrack;
    var media = data.media, rating = data.rating, content = data.content, price = data.price, cardLink = data.cardLink, action = data.action, productRatingSummary = data.productRatingSummary;
    var clickTracker = useClickTracker6();
    var track = useEgClickstream7();
    var onImageClick = React50.useCallback(function() {
        multiArmBanditTrack === null || multiArmBanditTrack === void 0 ? void 0 : multiArmBanditTrack();
        clickTracker(cardLink.clickAnalytics.referrerId, cardLink.clickAnalytics.linkName);
        if (cardLink.selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(cardLink.selectedAnalytics));
        }
        window.open(cardLink.resource.value, "_self");
    }, [
        cardLink,
        track,
        clickTracker,
        multiArmBanditTrack
    ]);
    var onClickCapture = function() {
        if (action === null || action === void 0 ? void 0 : action.selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(action.selectedAnalytics));
        }
        multiArmBanditTrack === null || multiArmBanditTrack === void 0 ? void 0 : multiArmBanditTrack();
        if (action === null || action === void 0 ? void 0 : action.clickAnalytics.referrerId) {
            clickTracker(action.clickAnalytics.referrerId, action.clickAnalytics.linkName, void 0);
        }
    };
    var isPaddedCard = cardContentSize === "PADDED_CARD" /* PADDED_CARD */ ;
    var renderActionLinkArea = function() {
        if (action === null || action === void 0 ? void 0 : action.button) {
            return /* @__PURE__ */ React50.createElement(EGDSSpacing25, {
                padding: {
                    blockstart: "three"
                }
            }, /* @__PURE__ */ React50.createElement(EGDSLink2, {
                theme: "inverse"
            }, /* @__PURE__ */ React50.createElement("a", {
                href: action.resource.value,
                onClickCapture: onClickCapture
            }, action.button.primary)));
        }
        return null;
    };
    var mediaTile = /* @__PURE__ */ React50.createElement(React50.Fragment, null, /* @__PURE__ */ React50.createElement("div", {
        className: isPaddedCard ? "uitk-layout-flex-block-size-full-size" : ""
    }, /* @__PURE__ */ React50.createElement(EGDSCardLink5, null, /* @__PURE__ */ React50.createElement(IncentivesActionLink, {
        data: cardLink,
        multiArmBanditTrack: multiArmBanditTrack,
        visuallyHidden: true
    })), /* @__PURE__ */ React50.createElement(IncentivesMedia, {
        carouselId: "incentives-media-tile-carousel-".concat(cardLink.clickAnalytics.referrerId),
        data: media,
        ratio: EGDSFigureAspectRatioType9.R16_9,
        onImageClick: onImageClick,
        roundedCorners: true
    }), /* @__PURE__ */ React50.createElement(EGDSThemeProvider, {
        config: {
            lightMode: {
                colorTheme: "dark-1",
                isGradient: true
            }
        },
        isColorThemeContainer: true
    }, /* @__PURE__ */ React50.createElement(EGDSSpacing25, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React50.createElement(EGDSLayoutFlex18, {
        direction: "column"
    }, /* @__PURE__ */ React50.createElement(EGDSLayoutFlexItem17, null, /* @__PURE__ */ React50.createElement(EGDSText14, {
        size: 200
    }, content.subTitle)), /* @__PURE__ */ React50.createElement(EGDSLayoutFlexItem17, null, /* @__PURE__ */ React50.createElement(EGDSSpacing25, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React50.createElement("div", null, /* @__PURE__ */ React50.createElement(Viewport9, null, /* @__PURE__ */ React50.createElement(ViewSmall9, null, /* @__PURE__ */ React50.createElement(EGDSHeading5, {
        overflow: "truncate-2-lines",
        size: 6,
        tag: "h3",
        style: {
            minHeight: "2.5rem"
        }
    }, content.title)), /* @__PURE__ */ React50.createElement(ViewMedium9, null, /* @__PURE__ */ React50.createElement(EGDSHeading5, {
        overflow: "truncate-2-lines",
        size: 5,
        tag: "h3",
        style: {
            minHeight: "3rem"
        }
    }, content.title)))))))), /* @__PURE__ */ React50.createElement(EGDSSpacing25, {
        margin: {
            blockstart: "one"
        }
    }, productRatingSummary ? /* @__PURE__ */ React50.createElement("div", null, /* @__PURE__ */ React50.createElement(ProductRatingSummary, {
        data: productRatingSummary,
        inline: true
    })) : rating.contents.length > 0 && /* @__PURE__ */ React50.createElement(Text, {
        textSize: 200,
        data: rating,
        inline: true
    })), /* @__PURE__ */ React50.createElement(EGDSSpacing25, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React50.createElement(IncentivesMediaTilePrice, {
        data: price
    }))), isPaddedCard && renderActionLinkArea()), !isPaddedCard && renderActionLinkArea());
    if (cardLink.presentedAnalytics) {
        return /* @__PURE__ */ React50.createElement(EgClickstreamImpressionTracker7, {
            eventData: buildClickstreamAnalyticsEvent(cardLink.presentedAnalytics)
        }, mediaTile);
    }
    return mediaTile;
};
IncentivesHeroMediaTile.fragment = __fragment20;
IncentivesHeroMediaTile.displayName = "IncentivesHeroMediaTile";
// src/components/collection/collection-lodging-carousel/views/hero-lodging-carousel.tsx
import { useMultiArmBanditContext as useMultiArmBanditContext2 } from "@shared-ui/retail-travel-content-experience-orchestration";
import { ViewMedium as ViewMedium10, Viewport as Viewport10, ViewSmall as ViewSmall10 } from "@shared-ui/viewport-context";
var HeroLodgingCarousel = function(props) {
    var _mediaBody_carouselCTAButton_button;
    var collectionHeader = props.collectionHeader, mediaBody = props.mediaBody, presentedAnalytics = props.presentedAnalytics, cardContentSize = props.cardContentSize, heroImage = props.heroImage, scrimHue = props.scrimHue, scrimSaturation = props.scrimSaturation, scrimLightness = props.scrimLightness;
    var formatText = useLocalization3().formatText;
    var track = useEgClickstream8();
    var clickTracker = useClickTracker7();
    var multiArmBanditTrack = useMultiArmBanditContext2().multiArmBanditTrack;
    var carouselIndex = -1;
    var handleCarouselAnalyticsByArrowClick = function(index) {
        if (carouselIndex === -1 && index === 0) {
            return;
        }
        var selectedAnalytics = index >= carouselIndex ? mediaBody.previousSelectedAnalytics : mediaBody.nextSelectedAnalytics;
        track(buildClickstreamAnalyticsEvent(selectedAnalytics));
        carouselIndex = index;
    };
    var onClickCapture = function() {
        var carouselButton = mediaBody.carouselCTAButton;
        if (carouselButton === null || carouselButton === void 0 ? void 0 : carouselButton.selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(carouselButton === null || carouselButton === void 0 ? void 0 : carouselButton.selectedAnalytics));
        }
        multiArmBanditTrack === null || multiArmBanditTrack === void 0 ? void 0 : multiArmBanditTrack();
        if (carouselButton === null || carouselButton === void 0 ? void 0 : carouselButton.clickAnalytics.referrerId) {
            clickTracker(carouselButton.clickAnalytics.referrerId, carouselButton.clickAnalytics.linkName, void 0);
        }
    };
    var carouselProps = {
        carouselName: "HeroLodgingCarousel",
        onIndexChange: handleCarouselAnalyticsByArrowClick,
        itemsVisible: {
            sm: 1,
            md: 2,
            lg: 4
        },
        pageBy: 1,
        buttonText: {
            nextButton: formatText("carousel.item.next") || "Next",
            prevButton: formatText("carousel.item.prev") || "Previous"
        },
        useContainerSizing: false,
        pagingInset: true,
        innerSpacing: {
            sm: 24,
            md: 32,
            lg: 48
        },
        peek: true
    };
    var smallBreakpointSpacing = "six";
    var medBreakpointSpacing = "eight";
    var largeBreakpointSpacing = "twelve";
    var heroHeaderSpacing = {
        padding: {
            small: {
                blockstart: "six",
                inline: smallBreakpointSpacing
            },
            medium: {
                blockstart: "eight",
                inline: medBreakpointSpacing
            },
            large: {
                blockstart: "twelve",
                inline: largeBreakpointSpacing
            }
        }
    };
    var heroCarouselSpacing = {
        padding: {
            blockstart: "three",
            small: {
                blockend: smallBreakpointSpacing
            },
            medium: {
                blockend: medBreakpointSpacing
            },
            large: {
                blockend: largeBreakpointSpacing
            }
        }
    };
    var scrimCustomColor = {
        h: scrimHue || 182,
        s: scrimSaturation || 78,
        l: scrimLightness || 12
    };
    var hasCollectionGraphicLink = collectionHeader === null || collectionHeader === void 0 ? void 0 : collectionHeader.collectionGraphicLink;
    var CollectionGraphicLink = hasCollectionGraphicLink && /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(IncentivesMediaLink, {
        data: collectionHeader.collectionGraphicLink
    }));
    var CollectionHeaderSubtitle = (collectionHeader === null || collectionHeader === void 0 ? void 0 : collectionHeader.subtitle) && /* @__PURE__ */ React51.createElement(EGDSSpacing26, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React51.createElement(EGDSTeamSubheadingBreakpointSizing, null, collectionHeader.subtitle));
    var HeroHeadingAndSummary = /* @__PURE__ */ React51.createElement("div", null, collectionHeader && /* @__PURE__ */ React51.createElement(Viewport10, null, /* @__PURE__ */ React51.createElement(ViewSmall10, null, /* @__PURE__ */ React51.createElement(React51.Fragment, null, /* @__PURE__ */ React51.createElement(EGDSTeamHeadingBreakpointSizing, {
        tag: "h2",
        size: 5
    }, collectionHeader.title), CollectionHeaderSubtitle)), /* @__PURE__ */ React51.createElement(ViewMedium10, null, /* @__PURE__ */ React51.createElement(React51.Fragment, null, /* @__PURE__ */ React51.createElement(EGDSTeamHeadingBreakpointSizing, {
        tag: "h2",
        size: 4
    }, collectionHeader.title), CollectionHeaderSubtitle))), mediaBody.summary && /* @__PURE__ */ React51.createElement(EGDSThemeProvider2, {
        config: {
            lightMode: {
                colorTheme: "dark-1",
                isGradient: true
            }
        },
        isColorThemeContainer: true
    }, /* @__PURE__ */ React51.createElement(EGDSSpacing26, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(IncentivesResultsSummary, {
        data: mediaBody.summary,
        textSize: 300
    })))));
    return /* @__PURE__ */ React51.createElement(React51.Fragment, null, presentedAnalytics && /* @__PURE__ */ React51.createElement(EgClickstreamImpressionTracker8, {
        trackOnce: true,
        eventData: buildClickstreamAnalyticsEvent(presentedAnalytics)
    }, /* @__PURE__ */ React51.createElement(EGDSTeamCardBorderRadiusIncrease, {
        containerize: true,
        tag: "section"
    }, /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizing, {
        columns: 1,
        className: "egds-team-layout-grid-container-based-sizing-has-top-spacer",
        rows: {
            small: [],
            medium: []
        }
    }, /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizingItem, {
        colSpan: "all",
        rowSpan: "all"
    }, /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(EGDSTeamFigureRefactor, {
        imageFit: "cover",
        ratio: "none",
        imageFitPositionY: "top"
    }, /* @__PURE__ */ React51.createElement(EGDSTeamImageRefactor, {
        blankDefault: true,
        src: heroImage === null || heroImage === void 0 ? void 0 : heroImage.image.url,
        alt: heroImage === null || heroImage === void 0 ? void 0 : heroImage.image.description,
        customBlankBackgroundColor: "hsl(".concat(scrimCustomColor.h, ", ").concat(scrimCustomColor.s, "%, ").concat(scrimCustomColor.l, "%)")
    })))), /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizingItem, {
        colSpan: "all",
        rowStart: 2,
        rowEnd: 3
    }, /* @__PURE__ */ React51.createElement(EGDSLayoutPosition2, {
        type: "relative"
    }, /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizing, {
        columns: 3,
        rows: [
            "min-content",
            "min-content"
        ]
    }, /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizingItem, {
        colSpan: "all",
        rowStart: 1,
        rowEnd: 2
    }, /* @__PURE__ */ React51.createElement(EGDSLayoutPosition2, {
        type: "relative",
        position: {
            zindex: "layer2"
        }
    }, /* @__PURE__ */ React51.createElement(EGDSTeamScrimRefactor, {
        type: "custom-fade-bottom",
        customColor: scrimCustomColor
    }, /* @__PURE__ */ React51.createElement(EGDSSpacing26, {
        padding: heroHeaderSpacing.padding
    }, /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(Viewport10, null, /* @__PURE__ */ React51.createElement(ViewSmall10, null, /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizing, {
        rows: 1,
        columns: [
            "1fr",
            "1fr",
            "1fr",
            "max-content"
        ],
        space: "three"
    }, /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizingItem, null, CollectionGraphicLink), /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizingItem, {
        colStart: 1,
        colEnd: 4
    }, HeroHeadingAndSummary))), /* @__PURE__ */ React51.createElement(ViewMedium10, null, /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizing, {
        rows: 1,
        columns: [
            "1fr",
            "1fr",
            "1fr",
            "auto",
            "auto",
            "auto"
        ],
        space: "twelve"
    }, /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizingItem, {
        alignSelf: hasCollectionGraphicLink ? "end" : void 0,
        colStart: 1,
        colEnd: 4
    }, HeroHeadingAndSummary), /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizingItem, {
        colStart: 4,
        colEnd: 7
    }, CollectionGraphicLink, mediaBody.carouselCTAButton && /* @__PURE__ */ React51.createElement(EGDSLayoutFlex19, {
        alignItems: "center"
    }, /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(IncentivesActionLink, {
        data: mediaBody.carouselCTAButton,
        multiArmBanditTrack: multiArmBanditTrack,
        inverseButton: true
    })))))))))))), /* @__PURE__ */ React51.createElement(EGDSTeamLayoutGridContainerBasedSizingItem, {
        colSpan: "all",
        rowStart: 2,
        rowEnd: 3
    }, /* @__PURE__ */ React51.createElement(EGDSTeamScrimRefactor, {
        type: "custom-overlay",
        customColor: scrimCustomColor
    }, /* @__PURE__ */ React51.createElement(EGDSSpacing26, {
        padding: heroCarouselSpacing.padding
    }, /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(EGDSCarousel4, _object_spread_props(_object_spread({}, carouselProps), {
        itemsMaxHeight: true
    }), mediaBody.tiles.map(function(item, index) {
        return /* @__PURE__ */ React51.createElement(IncentivesHeroMediaTile, {
            key: "collection-carousel-content-item-".concat(index),
            data: item,
            multiArmBanditTrack: multiArmBanditTrack,
            cardContentSize: cardContentSize
        });
    })))), mediaBody.carouselCTAButton && /* @__PURE__ */ React51.createElement(Viewport10, null, /* @__PURE__ */ React51.createElement(ViewSmall10, null, /* @__PURE__ */ React51.createElement(EGDSSpacing26, {
        margin: {
            small: {
                inlinestart: smallBreakpointSpacing,
                blockend: smallBreakpointSpacing
            }
        }
    }, /* @__PURE__ */ React51.createElement(EGDSLink3, {
        theme: "inverse"
    }, /* @__PURE__ */ React51.createElement("a", {
        href: mediaBody.carouselCTAButton.resource.value,
        onClickCapture: onClickCapture
    }, (_mediaBody_carouselCTAButton_button = mediaBody.carouselCTAButton.button) === null || _mediaBody_carouselCTAButton_button === void 0 ? void 0 : _mediaBody_carouselCTAButton_button.primary, /* @__PURE__ */ React51.createElement(EGDSIcon3, {
        name: "arrow_forward"
    }))))), /* @__PURE__ */ React51.createElement(ViewMedium10, null)))))))))));
};
HeroLodgingCarousel.displayName = "sharedui-HeroLodgingCarousel";
var _obj5;
// src/components/collection/collection-lodging-carousel/collection-lodging-carousel-views.ts
var LodgingCarouselViewMap = (_obj5 = {}, _define_property(_obj5, "default" /* Default */ , DefaultLodgingCarousel), _define_property(_obj5, "hero" /* Hero */ , HeroLodgingCarousel), _obj5);
// src/components/collection/collection-lodging-carousel/collection-lodging-carousel.tsx
var __Query3 = gql47(_templateObject46(), CollectionClickstreamAnalyticsFragment, IncentivesCollectionHeader.fragment, IncentivesMediaTile.fragment, IncentivesResultsSummary.fragment, IncentivesActionLink.fragment, CollectionHeroImage.fragment);
var CollectionLodgingCarousel = function(props) {
    var _data_collectionLodgingCarousel;
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_showPlaceholder = props.showPlaceholder, showPlaceholder = _props_showPlaceholder === void 0 ? true : _props_showPlaceholder, hideHeaderTitle = props.hideHeaderTitle, hideHeaderSubtitle = props.hideHeaderSubtitle, hideHeaderDescription = props.hideHeaderDescription, hideSummary = props.hideSummary, hideTermsAndConditions = props.hideTermsAndConditions, hideCarouselCTA = props.hideCarouselCTA, scrimHue = props.scrimHue, scrimSaturation = props.scrimSaturation, scrimLightness = props.scrimLightness, _props_cardContentSize = props.cardContentSize, cardContentSize = _props_cardContentSize === void 0 ? "FOUNDATION" /* FOUNDATION */  : _props_cardContentSize, _props_view = props.view, view = _props_view === void 0 ? "default" /* Default */  : _props_view;
    var context = useBexApi3().context;
    var uisTrack = useTracker();
    var variables = _object_spread_props(_object_spread({}, inputs || {}), {
        context: context,
        hideHeaderTitle: hideHeaderTitle !== null && hideHeaderTitle !== void 0 ? hideHeaderTitle : false,
        hideHeaderSubtitle: hideHeaderSubtitle !== null && hideHeaderSubtitle !== void 0 ? hideHeaderSubtitle : false,
        hideHeaderDescription: hideHeaderDescription !== null && hideHeaderDescription !== void 0 ? hideHeaderDescription : false,
        hideSummary: hideSummary !== null && hideSummary !== void 0 ? hideSummary : false,
        hideTermsAndConditions: hideTermsAndConditions !== null && hideTermsAndConditions !== void 0 ? hideTermsAndConditions : false,
        hideCarouselCTA: hideCarouselCTA !== null && hideCarouselCTA !== void 0 ? hideCarouselCTA : true
    });
    var _useQuery3 = useQuery3(__Query3, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery3.data, error = _useQuery3.error, loading = _useQuery3.loading;
    var analytics = data === null || data === void 0 ? void 0 : (_data_collectionLodgingCarousel = data.collectionLodgingCarousel) === null || _data_collectionLodgingCarousel === void 0 ? void 0 : _data_collectionLodgingCarousel.impressionAnalytics;
    useEffect(function() {
        if (analytics) {
            sendTracking(analytics, uisTrack);
        }
    }, [
        analytics,
        uisTrack
    ]);
    if (loading && showPlaceholder) {
        return /* @__PURE__ */ React52.createElement(Placeholder2, null);
    }
    if (error || !(data === null || data === void 0 ? void 0 : data.collectionLodgingCarousel.collectionBody)) {
        return null;
    }
    var LodgingCarousel = LodgingCarouselViewMap[view];
    if (!LodgingCarousel) {
        return null;
    }
    var _data_collectionLodgingCarousel1 = data.collectionLodgingCarousel, collectionHeader = _data_collectionLodgingCarousel1.collectionHeader, collectionBody = _data_collectionLodgingCarousel1.collectionBody, presentedAnalytics = _data_collectionLodgingCarousel1.presentedAnalytics, heroImage = _data_collectionLodgingCarousel1.heroImage;
    var mediaBody = collectionBody;
    var lodgingCarouselProps = {
        presentedAnalytics: presentedAnalytics,
        collectionHeader: collectionHeader,
        mediaBody: mediaBody,
        cardContentSize: cardContentSize,
        heroImage: heroImage,
        scrimHue: scrimHue,
        scrimSaturation: scrimSaturation,
        scrimLightness: scrimLightness
    };
    return /* @__PURE__ */ React52.createElement(LodgingCarousel, _object_spread({}, lodgingCarouselProps));
};
CollectionLodgingCarousel.displayName = "sharedui-CollectionLodgingCarousel";
// src/components/collection/collection-flights-carousel.tsx
import React53 from "react";
import { gql as gql48, useQuery as useQuery4 } from "@apollo/client";
import { EGDSCarousel as EGDSCarousel5 } from "@egds/react-core/carousel";
import { EGDSLayoutGrid as EGDSLayoutGrid5, EGDSLayoutGridItem as EGDSLayoutGridItem5 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing27 } from "@egds/react-core/spacing";
import { EGDSTab, EGDSTabs, EGDSTabsType } from "@egds/react-core/tabs";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker9, useEgClickstream as useEgClickstream9 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization4 } from "@shared-ui/localization-context";
var __Query4 = gql48(_templateObject47(), IncentivesOfferTile.fragment, IncentivesActionLink.fragment, IncentivesTileContent.fragment, CollectionClickstreamAnalyticsFragment, IncentivesCollectionHeader.fragment, IncentivesResultsSummary.fragment);
var CollectionFlightsCarousel = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, _param_showPlaceholder = param.showPlaceholder, showPlaceholder = _param_showPlaceholder === void 0 ? true : _param_showPlaceholder, hideHeaderTitle = param.hideHeaderTitle, hideHeaderSubtitle = param.hideHeaderSubtitle, hideHeaderDescription = param.hideHeaderDescription, hideSummary = param.hideSummary, hideTermsAndConditions = param.hideTermsAndConditions, tabBackground = param.tabBackground;
    var context = useBexApi4().context;
    var _React53_useState = _sliced_to_array(React53.useState(0), 2), activeTabIndex = _React53_useState[0], setActiveTab = _React53_useState[1];
    var formatText = useLocalization4().formatText;
    var track = useEgClickstream9();
    var shownTabIndexes = React53.useRef(/* @__PURE__ */ new Set([
        activeTabIndex
    ]));
    var variables = _object_spread_props(_object_spread({}, inputs || {}), {
        context: context,
        hideHeaderTitle: hideHeaderTitle !== null && hideHeaderTitle !== void 0 ? hideHeaderTitle : false,
        hideHeaderSubtitle: hideHeaderSubtitle !== null && hideHeaderSubtitle !== void 0 ? hideHeaderSubtitle : false,
        hideHeaderDescription: hideHeaderDescription !== null && hideHeaderDescription !== void 0 ? hideHeaderDescription : false,
        hideSummary: hideSummary !== null && hideSummary !== void 0 ? hideSummary : false,
        hideTermsAndConditions: hideTermsAndConditions !== null && hideTermsAndConditions !== void 0 ? hideTermsAndConditions : false
    });
    var _useQuery4 = useQuery4(__Query4, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery4.data, error = _useQuery4.error, loading = _useQuery4.loading;
    if (loading && showPlaceholder) {
        return /* @__PURE__ */ React53.createElement(Placeholder2, null);
    }
    if (error || !(data === null || data === void 0 ? void 0 : data.collectionFlightsCarousel.collectionBody)) {
        return null;
    }
    var _data_collectionFlightsCarousel = data.collectionFlightsCarousel, collectionHeader = _data_collectionFlightsCarousel.collectionHeader, collectionBody = _data_collectionFlightsCarousel.collectionBody, presentedAnalytics = _data_collectionFlightsCarousel.presentedAnalytics;
    var _ref = collectionHeader !== null && collectionHeader !== void 0 ? collectionHeader : {}, termsAndConditionsDialog = _ref.termsAndConditionsDialog, headerData = _object_without_properties(_ref, [
        "termsAndConditionsDialog"
    ]);
    var mediaBody = collectionBody;
    var carouselIndex = -1;
    var handleCarouselAnalyticsByArrowClick = function(index) {
        var _mediaBody_tiles_activeTabIndex;
        if (carouselIndex === -1 && index === 0) {
            return;
        }
        var selectedAnalytics = index >= carouselIndex ? (_mediaBody_tiles_activeTabIndex = mediaBody.tiles[activeTabIndex]) === null || _mediaBody_tiles_activeTabIndex === void 0 ? void 0 : _mediaBody_tiles_activeTabIndex.previousSelectedAnalytics : mediaBody.tiles[activeTabIndex].nextSelectedAnalytics;
        track(buildClickstreamAnalyticsEvent(selectedAnalytics));
        carouselIndex = index;
    };
    var handleCarouselAnalyticsByTab = function(index) {
        if (index === activeTabIndex) {
            return;
        }
        var newTab = mediaBody.tiles[index];
        if (!newTab) {
            return;
        }
        track(buildClickstreamAnalyticsEvent(newTab.selectedAnalytics));
    };
    var onSelectTab = function(tabIndex) {
        setActiveTab(tabIndex);
        shownTabIndexes.current.add(tabIndex);
        handleCarouselAnalyticsByTab(tabIndex);
    };
    var carouselProps = {
        onIndexChange: handleCarouselAnalyticsByArrowClick,
        itemsVisible: {
            sm: 1,
            md: 2,
            lg: 3,
            xl: 4
        },
        pageBy: 1,
        peek: true,
        buttonText: {
            nextButton: formatText("carousel.item.next") || "Next",
            prevButton: formatText("carousel.item.prev") || "Previous"
        },
        startIndex: 0,
        fullSheetVisible: true,
        itemsMaxHeight: true,
        useContainerSizing: false,
        wrapItems: true
    };
    return /* @__PURE__ */ React53.createElement(React53.Fragment, null, presentedAnalytics && /* @__PURE__ */ React53.createElement(EgClickstreamImpressionTracker9, {
        trackOnce: true,
        eventData: buildClickstreamAnalyticsEvent(presentedAnalytics)
    }, headerData && /* @__PURE__ */ React53.createElement(IncentivesCollectionHeader, {
        data: _object_spread({}, headerData),
        textSize: 300,
        multipleHeader: true,
        showTermsAndConditions: true,
        isLinkInline: true
    }), mediaBody.summary && /* @__PURE__ */ React53.createElement(EGDSSpacing27, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(IncentivesResultsSummary, {
        data: mediaBody.summary,
        textSize: 300
    }))), /* @__PURE__ */ React53.createElement(EGDSSpacing27, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React53.createElement(EGDSTabs, {
        role: "tablist",
        onTabSelect: onSelectTab,
        selectedTab: activeTabIndex,
        tabsType: EGDSTabsType.NATURAL,
        backgroundColor: tabBackground,
        scrollOffsetSelf: true
    }, mediaBody.tiles.map(function(item, index) {
        return /* @__PURE__ */ React53.createElement(EGDSTab, {
            key: "tab".concat(index),
            name: item.content.title,
            targetURI: "#flights".concat(index)
        }, shownTabIndexes.current.has(index) ? /* @__PURE__ */ React53.createElement(React53.Fragment, null, /* @__PURE__ */ React53.createElement(EGDSCarousel5, _object_spread({}, _object_spread_props(_object_spread({}, carouselProps), {
            carouselName: "collectionFlightsCarousel:".concat(item.content.title),
            carouselHeaderText: item.content.title
        })), item.offers.map(function(offer, tileIndex) {
            return /* @__PURE__ */ React53.createElement(IncentivesOfferTile, {
                key: "carousel-item-".concat(tileIndex),
                data: offer
            });
        })), /* @__PURE__ */ React53.createElement(EGDSSpacing27, {
            margin: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React53.createElement(EGDSLayoutGrid5, {
            areas: {
                small: [
                    "dialog",
                    "cta"
                ],
                medium: [
                    "cta dialog"
                ]
            },
            columns: {
                small: [
                    "max-content",
                    "1fr"
                ]
            },
            alignItems: "center",
            justifyItems: "end",
            space: "three"
        }, item.carouselCTAButton && /* @__PURE__ */ React53.createElement(EGDSLayoutGridItem5, {
            area: "cta",
            justifySelf: "start"
        }, /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(IncentivesActionLink, {
            data: item.carouselCTAButton
        }))), termsAndConditionsDialog && /* @__PURE__ */ React53.createElement(EGDSLayoutGridItem5, {
            area: "dialog"
        }, /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(CollectionDialog, {
            data: termsAndConditionsDialog,
            isLinkInline: true
        })))))) : null);
    })))));
};
CollectionFlightsCarousel.displayName = "sharedui-CollectionFlightsCarousel";
// src/components/collection/collection-packages-carousel/index.tsx
import React55, { useEffect as useEffect2 } from "react";
import { gql as gql50, useQuery as useQuery5 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
// src/components/collection/collection-packages-carousel/packages-carousel-body.tsx
import React54 from "react";
import { gql as gql49 } from "@apollo/client";
import { EGDSCarousel as EGDSCarousel6 } from "@egds/react-core/carousel";
import { EGDSLayoutGrid as EGDSLayoutGrid6, EGDSLayoutGridItem as EGDSLayoutGridItem6 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing28 } from "@egds/react-core/spacing";
import { EGDSTab as EGDSTab2, EGDSTabs as EGDSTabs2, EGDSTabsType as EGDSTabsType2 } from "@egds/react-core/tabs";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker10, useEgClickstream as useEgClickstream10 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization5 } from "@shared-ui/localization-context";
import { useMultiArmBanditContext as useMultiArmBanditContext3 } from "@shared-ui/retail-travel-content-experience-orchestration";
import { ViewMedium as ViewMedium11, Viewport as Viewport11, ViewSmall as ViewSmall11 } from "@shared-ui/viewport-context";
var __fragment21 = gql49(_templateObject48(), IncentivesResultsSummary.fragment, IncentivesActionLink.fragment, PackagesIncentivesMediaTile.fragment);
var PackagesCarouselBody = function(props) {
    var _React54_useState = _sliced_to_array(React54.useState(0), 2), activeTabIndex = _React54_useState[0], setActiveTab = _React54_useState[1];
    var formatText = useLocalization5().formatText;
    var track = useEgClickstream10();
    var multiArmBanditTrack = useMultiArmBanditContext3().multiArmBanditTrack;
    var shownTabIndexes = React54.useRef(/* @__PURE__ */ new Set([
        activeTabIndex
    ]));
    var collectionHeader = props.collectionHeader, collectionBody = props.collectionBody, presentedAnalytics = props.presentedAnalytics, cardContentSize = props.cardContentSize;
    var termsAndConditionsDialog = (collectionHeader !== null && collectionHeader !== void 0 ? collectionHeader : {}).termsAndConditionsDialog;
    var carouselIndex = -1;
    var handleCarouselAnalyticsByArrowClick = function(index) {
        if (carouselIndex === -1 && index === 0) {
            return;
        }
        var selectedAnalytics = index >= carouselIndex ? collectionBody.tiles[activeTabIndex].previousSelectedAnalytics : collectionBody.tiles[activeTabIndex].nextSelectedAnalytics;
        if (selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(selectedAnalytics));
        }
        carouselIndex = index;
    };
    var carouselProps = {
        carouselName: "PackagesCarousel",
        onIndexChange: handleCarouselAnalyticsByArrowClick,
        itemsGap: {
            sm: 12,
            md: 12,
            lg: 12
        },
        itemsVisible: {
            sm: 1,
            md: 2,
            lg: 4
        },
        pageBy: 1,
        peek: true,
        buttonText: {
            nextButton: formatText("carousel.item.next") || "Next",
            prevButton: formatText("carousel.item.prev") || "Previous"
        },
        pagingInset: true,
        itemsMaxHeight: true
    };
    var handleCarouselAnalyticsByTab = function(index) {
        if (index === activeTabIndex) {
            return;
        }
        var newTab = collectionBody.tiles[index];
        if (!newTab) {
            return;
        }
        if (newTab.selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(newTab.selectedAnalytics));
        }
    };
    var onSelectTab = function(tabIndex) {
        setActiveTab(tabIndex);
        shownTabIndexes.current.add(tabIndex);
        handleCarouselAnalyticsByTab(tabIndex);
    };
    var getOffersCarousel = function(item) {
        return item && /* @__PURE__ */ React54.createElement(React54.Fragment, null, /* @__PURE__ */ React54.createElement(EGDSCarousel6, _object_spread({}, _object_spread_props(_object_spread({}, carouselProps), {
            carouselName: "collectionPackagesCarousel:".concat(item.content.title),
            carouselHeaderText: item.content.title
        })), item.offers.map(function(offer, offerIndex) {
            return /* @__PURE__ */ React54.createElement(PackagesIncentivesMediaTile, {
                key: "collection-carousel-content-item-".concat(offerIndex),
                data: offer,
                multiArmBanditTrack: multiArmBanditTrack,
                cardContentSize: cardContentSize,
                multipleHeader: true
            });
        })), /* @__PURE__ */ React54.createElement(EGDSSpacing28, {
            margin: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React54.createElement(EGDSLayoutGrid6, {
            areas: {
                small: [
                    "dialog",
                    "cta"
                ],
                medium: [
                    "cta dialog"
                ]
            },
            columns: {
                small: [
                    "max-content",
                    "1fr"
                ]
            },
            alignItems: "center",
            justifyItems: "end",
            space: "three"
        }, item.ctaButton && /* @__PURE__ */ React54.createElement(EGDSLayoutGridItem6, {
            area: "cta",
            justifySelf: "start"
        }, /* @__PURE__ */ React54.createElement("div", null, /* @__PURE__ */ React54.createElement(IncentivesActionLink, {
            data: item.ctaButton
        }))), termsAndConditionsDialog && /* @__PURE__ */ React54.createElement(Viewport11, null, /* @__PURE__ */ React54.createElement(ViewSmall11, null, /* @__PURE__ */ React54.createElement(EGDSLayoutGridItem6, {
            area: "dialog",
            justifySelf: "start"
        }, /* @__PURE__ */ React54.createElement("div", null, /* @__PURE__ */ React54.createElement(CollectionDialog, {
            data: termsAndConditionsDialog
        })))), /* @__PURE__ */ React54.createElement(ViewMedium11, null, /* @__PURE__ */ React54.createElement(EGDSLayoutGridItem6, {
            area: "dialog"
        }, /* @__PURE__ */ React54.createElement("div", null, /* @__PURE__ */ React54.createElement(CollectionDialog, {
            data: termsAndConditionsDialog
        }))))))));
    };
    var getCarousel = function() {
        return /* @__PURE__ */ React54.createElement(React54.Fragment, null, collectionHeader && /* @__PURE__ */ React54.createElement(IncentivesCollectionHeader, {
            data: collectionHeader,
            multipleHeader: true,
            textSize: 300
        }), collectionBody.tiles.length ? /* @__PURE__ */ React54.createElement(EGDSSpacing28, {
            margin: {
                blockstart: "three"
            }
        }, collectionBody.tiles.length > 1 ? /* @__PURE__ */ React54.createElement(EGDSTabs2, {
            role: "tablist",
            onTabSelect: onSelectTab,
            selectedTab: activeTabIndex,
            tabsType: EGDSTabsType2.NATURAL,
            scrollOffsetSelf: true
        }, collectionBody.tiles.map(function(item, index) {
            return /* @__PURE__ */ React54.createElement(EGDSTab2, {
                key: "tab".concat(index),
                name: item.content.title,
                targetURI: "#packages".concat(index)
            }, shownTabIndexes.current.has(index) ? getOffersCarousel(item) : null);
        })) : getOffersCarousel(collectionBody.tiles[0])) : null);
    };
    return presentedAnalytics ? /* @__PURE__ */ React54.createElement(EgClickstreamImpressionTracker10, {
        trackOnce: true,
        eventData: buildClickstreamAnalyticsEvent(presentedAnalytics)
    }, getCarousel()) : getCarousel();
};
PackagesCarouselBody.fragment = __fragment21;
PackagesCarouselBody.displayName = "PackagesCarouselBody";
// src/components/collection/collection-packages-carousel/index.tsx
var __Query5 = gql50(_templateObject49(), CollectionClickstreamAnalyticsFragment, IncentivesCollectionHeader.fragment, PackagesCarouselBody.fragment);
var CollectionPackagesCarousel = function(props) {
    var _data_collectionPackagesCarousel;
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_showPlaceholder = props.showPlaceholder, showPlaceholder = _props_showPlaceholder === void 0 ? true : _props_showPlaceholder, hideHeaderTitle = props.hideHeaderTitle, hideHeaderSubtitle = props.hideHeaderSubtitle, hideHeaderDescription = props.hideHeaderDescription, hideSummary = props.hideSummary, hideTermsAndConditions = props.hideTermsAndConditions, hideCarouselCTA = props.hideCarouselCTA, _props_cardContentSize = props.cardContentSize, cardContentSize = _props_cardContentSize === void 0 ? "FOUNDATION" /* FOUNDATION */  : _props_cardContentSize;
    var context = useBexApi5().context;
    var uisTrack = useTracker();
    var variables = _object_spread_props(_object_spread({}, inputs || {}), {
        context: context,
        hideHeaderTitle: hideHeaderTitle !== null && hideHeaderTitle !== void 0 ? hideHeaderTitle : false,
        hideHeaderSubtitle: hideHeaderSubtitle !== null && hideHeaderSubtitle !== void 0 ? hideHeaderSubtitle : false,
        hideHeaderDescription: hideHeaderDescription !== null && hideHeaderDescription !== void 0 ? hideHeaderDescription : false,
        hideSummary: hideSummary !== null && hideSummary !== void 0 ? hideSummary : false,
        hideTermsAndConditions: hideTermsAndConditions !== null && hideTermsAndConditions !== void 0 ? hideTermsAndConditions : false,
        hideCarouselCTA: hideCarouselCTA !== null && hideCarouselCTA !== void 0 ? hideCarouselCTA : true
    });
    var _useQuery5 = useQuery5(__Query5, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery5.data, error = _useQuery5.error, loading = _useQuery5.loading;
    var analytics = data === null || data === void 0 ? void 0 : (_data_collectionPackagesCarousel = data.collectionPackagesCarousel) === null || _data_collectionPackagesCarousel === void 0 ? void 0 : _data_collectionPackagesCarousel.impressionAnalytics;
    useEffect2(function() {
        if (analytics) {
            sendTracking(analytics, uisTrack);
        }
    }, [
        analytics,
        uisTrack
    ]);
    if (loading && showPlaceholder) {
        return /* @__PURE__ */ React55.createElement(PackagesCarouselPlaceholder, null);
    }
    if (error || !(data === null || data === void 0 ? void 0 : data.collectionPackagesCarousel.collectionBody)) {
        return null;
    }
    var _data_collectionPackagesCarousel1 = data.collectionPackagesCarousel, collectionHeader = _data_collectionPackagesCarousel1.collectionHeader, collectionBody = _data_collectionPackagesCarousel1.collectionBody, presentedAnalytics = _data_collectionPackagesCarousel1.presentedAnalytics;
    var packagesCarouselProps = {
        presentedAnalytics: presentedAnalytics,
        collectionHeader: collectionHeader,
        collectionBody: collectionBody,
        cardContentSize: cardContentSize
    };
    return /* @__PURE__ */ React55.createElement(PackagesCarouselBody, _object_spread({}, packagesCarouselProps));
};
CollectionPackagesCarousel.displayName = "sharedui-CollectionPackagesCarousel";
export { CollectionFlightsCarousel, CollectionItemClickthrough, CollectionLodgingCarousel, CollectionPackagesCarousel, CollectionType, IncentivesCollectionGrid, IncentivesCollectionView };
//# sourceMappingURL=index.js.map